<div
  class="both closeAllButton translate-top-most"
  [resizeDom]="layoutdata"
  [ngStyle]="{ visibility: display != 0 ? 'visible' : 'hidden' }"
  (click)="buttonClick('close')"
></div>
<pinch-zoom
  [minScale]="1"
  [disableZoomControl]="'disable'"
  class="both zoom-container translate-top-most"
  [backgroundColor]="'rgba(0, 0, 0, 0)'"
  [ngStyle]="{
    width: scaleR.offsetLeft * 2 + 1280 * scaleR.scaleX + 'px',
    height: scaleR.offsetTop * 2 + 720 * scaleR.scaleX + 'px',
    top: 0 * scaleR.scaleX + 'px',
    left: 0 * scaleR.scaleX + 'px'
  }"
>
  <div
    class="help-container translate-top-most"
    (click)="buttonClick('close')"
  ></div>
  <div
    [resizeDom]="helpContentStage"
    class="both helpbackground pointernone translate-top-most no-scroll-bar"
    [ngStyle]="{ visibility: display == 1 ? 'visible' : 'hidden' }"
  >
    <img
      class="both tnimage-zoom translate-top-most"
      src="assets/images/help/fc21/{{ language }}/{{ language }}_{{
        imgBackGround
      }}?t={{ version }}"
    />
  </div>
  <div
    *ngIf="tutorialCount == 18 && display == 1"
    [resizeDom]="helpContentStageNoResizeChild1"
    class="both helpbackground pointernone translate-top-most no-scroll-bar"
  >
    <img
      *ngIf="
        (currentQuickTipsID === 100 || currentQuickTipsID === 101) &&
        currentQuickTipsID != -1 &&
        rouletteScore == 17
      "
      [src]="
        getImageFromQuickTipsSprite(
          'fc21_Tutorial_18_Russian_Roulette_hh_highlight@2x'
        )
      "
      [ngStyle]="{
        width: rouletteposition[language].bgWidth * scaleR.scaleX + 'px',
        height: rouletteposition[language].bgHeight * scaleR.scaleX + 'px',
        top: rouletteposition[language].bgTop * scaleR.scaleX + 'px',
        left: rouletteposition[language].bg17Left * scaleR.scaleX + 'px'
      }"
      class="both button rr-id rr-17-en"
    />
    <img
      *ngIf="
        (currentQuickTipsID === 103 || currentQuickTipsID === 104) &&
        currentQuickTipsID != -1 &&
        rouletteScore == 18
      "
      [src]="
        getImageFromQuickTipsSprite(
          'fc21_Tutorial_18_Russian_Roulette_hh_highlight@2x'
        )
      "
      [ngStyle]="{
        width: rouletteposition[language].bgWidth * scaleR.scaleX + 'px',
        height: rouletteposition[language].bgHeight * scaleR.scaleX + 'px',
        top: rouletteposition[language].bgTop * scaleR.scaleX + 'px',
        left: rouletteposition[language].bg18Left * scaleR.scaleX + 'px'
      }"
      class="both button rr-id rr-18-en"
    />
    <img
      *ngIf="
        (currentQuickTipsID === 106 || currentQuickTipsID === 107) &&
        currentQuickTipsID != -1 &&
        rouletteScore == 19
      "
      [src]="
        getImageFromQuickTipsSprite(
          'fc21_Tutorial_18_Russian_Roulette_hh_highlight@2x'
        )
      "
      [ngStyle]="{
        width: rouletteposition[language].bgWidth * scaleR.scaleX + 'px',
        height: rouletteposition[language].bgHeight * scaleR.scaleX + 'px',
        top: rouletteposition[language].bgTop * scaleR.scaleX + 'px',
        left: rouletteposition[language].bg19Left * scaleR.scaleX + 'px'
      }"
      class="both button rr-id rr-19-en"
    />
    <img
      *ngIf="
        (currentQuickTipsID === 109 || currentQuickTipsID === 110) &&
        currentQuickTipsID != -1 &&
        rouletteScore == 20
      "
      [src]="
        getImageFromQuickTipsSprite(
          'fc21_Tutorial_18_Russian_Roulette_hh_highlight@2x'
        )
      "
      [ngStyle]="{
        width: rouletteposition[language].bgWidth * scaleR.scaleX + 'px',
        height: rouletteposition[language].bgHeight * scaleR.scaleX + 'px',
        top: rouletteposition[language].bgTop * scaleR.scaleX + 'px',
        left: rouletteposition[language].bg20Left * scaleR.scaleX + 'px'
      }"
      class="both button rr-id rr-20-en"
    />

    <img
      *ngIf="currentQuickTipsID !== 100 && currentQuickTipsID !== 101"
      [ngStyle]="{
        width:
          pays_blank_tutorial['TN_pays_blank_position_' + tutorialCount][0]
            .width *
            scaleR.scaleX +
          'px',
        height:
          pays_blank_tutorial['TN_pays_blank_position_' + tutorialCount][0]
            .height *
            scaleR.scaleX +
          'px',
        left:
          pays_blank_tutorial['TN_pays_blank_position_' + tutorialCount][0]
            .left[language] *
            scaleR.scaleX +
          'px',
        top:
          pays_blank_tutorial['TN_pays_blank_position_' + tutorialCount][0]
            .top *
            scaleR.scaleX +
          'px'
      }"
      class="both button"
      src="assets/images/help/common/pays_blank_small@2x.webp"
    />
    <img
      *ngIf="currentQuickTipsID !== 103 && currentQuickTipsID !== 104"
      [ngStyle]="{
        width:
          pays_blank_tutorial['TN_pays_blank_position_' + tutorialCount][1]
            .width *
            scaleR.scaleX +
          'px',
        height:
          pays_blank_tutorial['TN_pays_blank_position_' + tutorialCount][1]
            .height *
            scaleR.scaleX +
          'px',
        left:
          pays_blank_tutorial['TN_pays_blank_position_' + tutorialCount][1]
            .left[language] *
            scaleR.scaleX +
          'px',
        top:
          pays_blank_tutorial['TN_pays_blank_position_' + tutorialCount][1]
            .top *
            scaleR.scaleX +
          'px'
      }"
      class="both button"
      src="assets/images/help/common/pays_blank_small@2x.webp"
    />
    <img
      *ngIf="currentQuickTipsID !== 106 && currentQuickTipsID !== 107"
      [ngStyle]="{
        width:
          pays_blank_tutorial['TN_pays_blank_position_' + tutorialCount][2]
            .width *
            scaleR.scaleX +
          'px',
        height:
          pays_blank_tutorial['TN_pays_blank_position_' + tutorialCount][2]
            .height *
            scaleR.scaleX +
          'px',
        left:
          pays_blank_tutorial['TN_pays_blank_position_' + tutorialCount][2]
            .left[language] *
            scaleR.scaleX +
          'px',
        top:
          pays_blank_tutorial['TN_pays_blank_position_' + tutorialCount][2]
            .top *
            scaleR.scaleX +
          'px'
      }"
      class="both button"
      src="assets/images/help/common/pays_blank_small@2x.webp"
    />
    <img
      *ngIf="currentQuickTipsID !== 109 && currentQuickTipsID !== 110"
      [ngStyle]="{
        width:
          pays_blank_tutorial['TN_pays_blank_position_' + tutorialCount][3]
            .width *
            scaleR.scaleX +
          'px',
        height:
          pays_blank_tutorial['TN_pays_blank_position_' + tutorialCount][3]
            .height *
            scaleR.scaleX +
          'px',
        left:
          pays_blank_tutorial['TN_pays_blank_position_' + tutorialCount][3]
            .left[language] *
            scaleR.scaleX +
          'px',
        top:
          pays_blank_tutorial['TN_pays_blank_position_' + tutorialCount][3]
            .top *
            scaleR.scaleX +
          'px'
      }"
      class="both button"
      src="assets/images/help/common/pays_blank_small@2x.webp"
    />
  </div>
  <!--tutorial-->
  <div
    [resizeDom]="helpContentStage"
    class="both helpbackground translate-top-most no-scroll-bar"
    [ngStyle]="{ visibility: display == 1 ? 'visible' : 'hidden' }"
  >
    <div
      class="help-container-bg translate-top-most"
      (click)="buttonClick('close')"
    ></div>
    <div class="tnimage-zoom translate-top-most">
      <div
        [ngStyle]="{
          display:
            tutorialCount == 3 && language != 'he' && language != 'ar'
              ? 'block'
              : 'none'
        }"
        class="dynamic-card-container translate-top-most"
      >
        <div
          class="hand-container-22 id-94"
          [ngStyle]="{ display: currentQuickTipsID === 113 ? 'block' : 'none' }"
        >
          <img
            class="img-hand"
            [src]="getImageFromQuickTipsSprite('22_hand@2x')"
          />
          <div class="handTextstyle hand-22" [resizeText]="19">
            {{ currentQuickTipsID }}
          </div>
        </div>
      </div>
      <div
        [ngStyle]="{
          display:
            tutorialCount == 3 && (language == 'he' || language == 'ar')
              ? 'block'
              : 'none'
        }"
        class="dynamic-card-container translate-top-most"
      >
        <div
          class="hand-container-92 id-94-ar"
          [ngStyle]="{ display: currentQuickTipsID === 113 ? 'block' : 'none' }"
        >
          <img
            class="img-hand"
            [src]="getImageFromQuickTipsSprite('92_hand@2x')"
          />
          <div class="handTextstyle hand-92" [resizeText]="21">
            {{ currentQuickTipsID }}
          </div>
        </div>
      </div>

      <img
        appPinchZoom
        class="both tnimage settings1 pointernone translate-top-most"
        [ngStyle]="{
          display:
            language !== 'ar' &&
            language !== 'he' &&
            language !== 'zh-Hant' &&
            language !== 'ta-IN'
              ? 'block'
              : 'none'
        }"
        src="assets/images/help/fc21/{{ language }}/{{ language }}_{{
          tutorialContent['TN_image_' + tutorialCount]
        }}?t={{ version }}"
      />
      <img
        appPinchZoom
        class="both tnimage settings1 pointernone translate-top-most"
        [ngStyle]="{
          display: language === 'ar' && tutorialCount !== 1 ? 'block' : 'none'
        }"
        src="assets/images/help/fc21/{{ language }}/{{ language }}_{{
          tutorialContent['TN_image_' + tutorialCount]
        }}?t={{ version }}"
      />
      <img
        appPinchZoom
        class="both tnimage settings1 pointernone translate-top-most"
        [ngStyle]="{
          display: language === 'he' && tutorialCount !== 5 ? 'block' : 'none'
        }"
        src="assets/images/help/fc21/{{ language }}/{{ language }}_{{
          tutorialContent['TN_image_' + tutorialCount]
        }}?t={{ version }}"
      />
      <img
        appPinchZoom
        class="both tnimage settings1 pointernone translate-top-most"
        [ngStyle]="{
          display:
            language === 'ta-IN' && tutorialCount !== 6 ? 'block' : 'none'
        }"
        src="assets/images/help/fc21/{{ language }}/{{ language }}_{{
          tutorialContent['TN_image_' + tutorialCount]
        }}?t={{ version }}"
      />
      <img
        appPinchZoom
        class="both tnimage settings1 pointernone translate-top-most"
        [ngStyle]="{
          display:
            language === 'zh-Hant' &&
            tutorialCount !== 6 &&
            tutorialCount !== 7 &&
            tutorialCount !== 12 &&
            tutorialCount !== 15 &&
            tutorialCount !== 20 &&
            tutorialCount !== 8 &&
            tutorialCount !== 9 &&
            tutorialCount !== 10 &&
            tutorialCount !== 11
              ? 'block'
              : 'none'
        }"
        src="assets/images/help/fc21/{{ language }}/{{ language }}_{{
          tutorialContent['TN_image_' + tutorialCount]
        }}?t={{ version }}"
      />
      <img
        appPinchZoom
        class="both tnimage settings1 pointernone translate-top-most tutorial-content-ar"
        [ngStyle]="{
          display: language === 'ar' && tutorialCount === 1 ? 'block' : 'none'
        }"
        src="assets/images/help/fc21/{{ language }}/{{ language }}_{{
          tutorialContent['TN_image_' + tutorialCount]
        }}?t={{ version }}"
      />
      <img
        appPinchZoom
        class="both tnimage settings1 pointernone translate-top-most tutorial-content-he"
        [ngStyle]="{
          display: language === 'he' && tutorialCount === 5 ? 'block' : 'none'
        }"
        src="assets/images/help/fc21/{{ language }}/{{ language }}_{{
          tutorialContent['TN_image_' + tutorialCount]
        }}?t={{ version }}"
      />
      <img
        appPinchZoom
        class="both tnimage settings1 pointernone translate-top-most tutorial-content-zh-Hant"
        [ngStyle]="{
          display:
            language === 'zh-Hant' &&
            (tutorialCount === 6 ||
              tutorialCount === 7 ||
              tutorialCount === 12 ||
              tutorialCount === 15 ||
              tutorialCount === 20 ||
              tutorialCount === 8 ||
              tutorialCount === 9 ||
              tutorialCount === 10 ||
              tutorialCount === 11)
              ? 'block'
              : 'none'
        }"
        src="assets/images/help/fc21/{{ language }}/{{ language }}_{{
          tutorialContent['TN_image_' + tutorialCount]
        }}?t={{ version }}"
      />
      <img
        appPinchZoom
        class="both tnimage settings1 pointernone translate-top-most tutorial-content-ta-IN"
        [ngStyle]="{
          display:
            language === 'ta-IN' && tutorialCount === 6 ? 'block' : 'none'
        }"
        src="assets/images/help/fc21/{{ language }}/{{ language }}_{{
          tutorialContent['TN_image_' + tutorialCount]
        }}?t={{ version }}"
      />

      <div
        [ngStyle]="{
          display:
            tutorialCount == 14 && language != 'he' && language != 'ar'
              ? 'block'
              : 'none'
        }"
        class="dynamic-card-container translate-top-most"
      >
        <div
          class="hand-container-14 id-88"
          [ngStyle]="{ display: currentQuickTipsID == 88 ? 'block' : 'none' }"
        >
          <img
            class="img-hand"
            [src]="getImageFromQuickTipsSprite('22_hand@2x')"
          />
          <div class="handTextstyle hand-22" [resizeText]="22">
            {{ currentQuickTipsID }}
          </div>
        </div>
        <div
          class="hand-container-14 id-89"
          [ngStyle]="{ display: currentQuickTipsID == 89 ? 'block' : 'none' }"
        >
          <img
            class="img-hand"
            [src]="getImageFromQuickTipsSprite('22_hand@2x')"
          />
          <div class="handTextstyle hand-22" [resizeText]="22">
            {{ currentQuickTipsID }}
          </div>
        </div>
        <div
          class="hand-container-14 id-90"
          [ngStyle]="{ display: currentQuickTipsID == 90 ? 'block' : 'none' }"
        >
          <img
            class="img-hand"
            [src]="getImageFromQuickTipsSprite('22_hand@2x')"
          />
          <div class="handTextstyle hand-22" [resizeText]="22">
            {{ currentQuickTipsID }}
          </div>
        </div>
      </div>
      <div
        [ngStyle]="{
          display:
            tutorialCount == 14 && (language == 'he' || language == 'ar')
              ? 'block'
              : 'none'
        }"
        class="dynamic-card-container translate-top-most"
      >
        <div
          class="hand-container-14 id-88-ar"
          [ngStyle]="{ display: currentQuickTipsID == 88 ? 'block' : 'none' }"
        >
          <img
            class="img-hand"
            [src]="getImageFromQuickTipsSprite('92_hand@2x')"
          />
          <div class="handTextstyle hand-92" [resizeText]="22">
            {{ currentQuickTipsID }}
          </div>
        </div>
        <div
          class="hand-container-14 id-89-ar"
          [ngStyle]="{ display: currentQuickTipsID == 89 ? 'block' : 'none' }"
        >
          <img
            class="img-hand"
            [src]="getImageFromQuickTipsSprite('92_hand@2x')"
          />
          <div class="handTextstyle hand-92" [resizeText]="22">
            {{ currentQuickTipsID }}
          </div>
        </div>
        <div
          class="hand-container-14 id-90-ar"
          [ngStyle]="{ display: currentQuickTipsID == 90 ? 'block' : 'none' }"
        >
          <img
            class="img-hand"
            [src]="getImageFromQuickTipsSprite('92_hand@2x')"
          />
          <div class="handTextstyle hand-92" [resizeText]="22">
            {{ currentQuickTipsID }}
          </div>
        </div>
      </div>
      <div
        [ngStyle]="{ display: tutorialCount == 15 ? 'block' : 'none' }"
        class="dynamic-card-container translate-top-most"
      >
        <div
          class="hand-container-52 id-91-1-en"
          [ngStyle]="{
            display:
              language == 'en' &&
              (currentQuickTipsID == 91 || currentQuickTipsID == 92)
                ? 'block'
                : 'none'
          }"
        >
          <img
            class="img-hand"
            [src]="getImageFromQuickTipsSprite('52_hand@2x')"
          />
          <div class="handTextstyle hand-52" [resizeText]="22">
            {{ currentQuickTipsID }}
          </div>
        </div>
        <div
          class="hand-container-52 id-91-2-en"
          [ngStyle]="{
            display:
              language == 'en' &&
              (currentQuickTipsID == 91 || currentQuickTipsID == 92)
                ? 'block'
                : 'none'
          }"
        >
          <img
            class="img-hand"
            [src]="getImageFromQuickTipsSprite('52_hand@2x')"
          />
          <div class="handTextstyle hand-52" [resizeText]="22">
            {{ currentQuickTipsID }}
          </div>
        </div>
        <div
          class="hand-container-52 id-91-1-ar"
          [ngStyle]="{
            display:
              language == 'ar' &&
              (currentQuickTipsID == 91 || currentQuickTipsID == 92)
                ? 'block'
                : 'none'
          }"
        >
          <img
            class="img-hand"
            [src]="getImageFromQuickTipsSprite('52_hand@2x')"
          />
          <div class="handTextstyle hand-52" [resizeText]="22">
            {{ currentQuickTipsID }}
          </div>
        </div>
        <div
          class="hand-container-52 id-91-2-ar"
          [ngStyle]="{
            display:
              language == 'ar' &&
              (currentQuickTipsID == 91 || currentQuickTipsID == 92)
                ? 'block'
                : 'none'
          }"
        >
          <img
            class="img-hand"
            [src]="getImageFromQuickTipsSprite('52_hand@2x')"
          />
          <div class="handTextstyle hand-52" [resizeText]="22">
            {{ currentQuickTipsID }}
          </div>
        </div>
        <div
          class="hand-container-52 id-91-1-bg"
          [ngStyle]="{
            display:
              (language == 'bg' ||
                language == 'cs' ||
                language == 'da' ||
                language == 'es') &&
              (currentQuickTipsID == 91 || currentQuickTipsID == 92)
                ? 'block'
                : 'none'
          }"
        >
          <img
            class="img-hand"
            [src]="getImageFromQuickTipsSprite('52_hand@2x')"
          />
          <div class="handTextstyle hand-52" [resizeText]="22">
            {{ currentQuickTipsID }}
          </div>
        </div>
        <div
          class="hand-container-52 id-91-2-bg"
          [ngStyle]="{
            display:
              (language == 'bg' ||
                language == 'cs' ||
                language == 'da' ||
                language == 'es') &&
              (currentQuickTipsID == 91 || currentQuickTipsID == 92)
                ? 'block'
                : 'none'
          }"
        >
          <img
            class="img-hand"
            [src]="getImageFromQuickTipsSprite('52_hand@2x')"
          />
          <div class="handTextstyle hand-52" [resizeText]="22">
            {{ currentQuickTipsID }}
          </div>
        </div>
        <div
          class="hand-container-52 id-91-1-de"
          [ngStyle]="{
            display:
              language == 'de' &&
              (currentQuickTipsID == 91 || currentQuickTipsID == 92)
                ? 'block'
                : 'none'
          }"
        >
          <img
            class="img-hand"
            [src]="getImageFromQuickTipsSprite('52_hand@2x')"
          />
          <div class="handTextstyle hand-52" [resizeText]="22">
            {{ currentQuickTipsID }}
          </div>
        </div>
        <div
          class="hand-container-52 id-91-2-de"
          [ngStyle]="{
            display:
              language == 'de' &&
              (currentQuickTipsID == 91 || currentQuickTipsID == 92)
                ? 'block'
                : 'none'
          }"
        >
          <img
            class="img-hand"
            [src]="getImageFromQuickTipsSprite('52_hand@2x')"
          />
          <div class="handTextstyle hand-52" [resizeText]="22">
            {{ currentQuickTipsID }}
          </div>
        </div>
        <div
          class="hand-container-34 id-91-1-ee"
          [ngStyle]="{
            display:
              language == 'ee' &&
              (currentQuickTipsID == 91 || currentQuickTipsID == 92)
                ? 'block'
                : 'none'
          }"
        >
          <img
            class="img-hand"
            [src]="getImageFromQuickTipsSprite('34_hand@2x')"
          />
          <div class="handTextstyle hand-34" [resizeText]="22">
            {{ currentQuickTipsID }}
          </div>
        </div>
        <div
          class="hand-container-34 id-91-2-ee"
          [ngStyle]="{
            display:
              language == 'ee' &&
              (currentQuickTipsID == 91 || currentQuickTipsID == 92)
                ? 'block'
                : 'none'
          }"
        >
          <img
            class="img-hand"
            [src]="getImageFromQuickTipsSprite('34_hand@2x')"
          />
          <div class="handTextstyle hand-34" [resizeText]="22">
            {{ currentQuickTipsID }}
          </div>
        </div>
        <div
          class="hand-container-52 id-91-1-fi"
          [ngStyle]="{
            display:
              language == 'fi' &&
              (currentQuickTipsID == 91 || currentQuickTipsID == 92)
                ? 'block'
                : 'none'
          }"
        >
          <img
            class="img-hand"
            [src]="getImageFromQuickTipsSprite('52_hand@2x')"
          />
          <div class="handTextstyle hand-52" [resizeText]="22">
            {{ currentQuickTipsID }}
          </div>
        </div>
        <div
          class="hand-container-52 id-91-2-fi"
          [ngStyle]="{
            display:
              language == 'fi' &&
              (currentQuickTipsID == 91 || currentQuickTipsID == 92)
                ? 'block'
                : 'none'
          }"
        >
          <img
            class="img-hand"
            [src]="getImageFromQuickTipsSprite('52_hand@2x')"
          />
          <div class="handTextstyle hand-52" [resizeText]="22">
            {{ currentQuickTipsID }}
          </div>
        </div>
        <div
          class="hand-container-52 id-91-1-fr"
          [ngStyle]="{
            display:
              language == 'fr' &&
              (currentQuickTipsID == 91 || currentQuickTipsID == 92)
                ? 'block'
                : 'none'
          }"
        >
          <img
            class="img-hand"
            [src]="getImageFromQuickTipsSprite('52_hand@2x')"
          />
          <div class="handTextstyle hand-52" [resizeText]="22">
            {{ currentQuickTipsID }}
          </div>
        </div>
        <div
          class="hand-container-52 id-91-2-fr"
          [ngStyle]="{
            display:
              language == 'fr' &&
              (currentQuickTipsID == 91 || currentQuickTipsID == 92)
                ? 'block'
                : 'none'
          }"
        >
          <img
            class="img-hand"
            [src]="getImageFromQuickTipsSprite('52_hand@2x')"
          />
          <div class="handTextstyle hand-52" [resizeText]="22">
            {{ currentQuickTipsID }}
          </div>
        </div>
        <div
          class="hand-container-55 id-91-1-ge"
          [ngStyle]="{
            display:
              language == 'ge' &&
              (currentQuickTipsID == 91 || currentQuickTipsID == 92)
                ? 'block'
                : 'none'
          }"
        >
          <img
            class="img-hand"
            [src]="getImageFromQuickTipsSprite('55_hand@2x')"
          />
          <div class="handTextstyle hand-55" [resizeText]="22">
            {{ currentQuickTipsID }}
          </div>
        </div>
        <div
          class="hand-container-55 id-91-2-ge"
          [ngStyle]="{
            display:
              language == 'ge' &&
              (currentQuickTipsID == 91 || currentQuickTipsID == 92)
                ? 'block'
                : 'none'
          }"
        >
          <img
            class="img-hand"
            [src]="getImageFromQuickTipsSprite('55_hand@2x')"
          />
          <div class="handTextstyle hand-55" [resizeText]="22">
            {{ currentQuickTipsID }}
          </div>
        </div>
        <div
          class="hand-container-34 id-91-1-gr"
          [ngStyle]="{
            display:
              language == 'gr' &&
              (currentQuickTipsID == 91 || currentQuickTipsID == 92)
                ? 'block'
                : 'none'
          }"
        >
          <img
            class="img-hand"
            [src]="getImageFromQuickTipsSprite('34_hand@2x')"
          />
          <div class="handTextstyle hand-34" [resizeText]="22">
            {{ currentQuickTipsID }}
          </div>
        </div>
        <div
          class="hand-container-34 id-91-2-gr"
          [ngStyle]="{
            display:
              language == 'gr' &&
              (currentQuickTipsID == 91 || currentQuickTipsID == 92)
                ? 'block'
                : 'none'
          }"
        >
          <img
            class="img-hand"
            [src]="getImageFromQuickTipsSprite('34_hand@2x')"
          />
          <div class="handTextstyle hand-34" [resizeText]="22">
            {{ currentQuickTipsID }}
          </div>
        </div>
        <div
          class="hand-container-55 id-91-1-he"
          [ngStyle]="{
            display:
              language == 'he' &&
              (currentQuickTipsID == 91 || currentQuickTipsID == 92)
                ? 'block'
                : 'none'
          }"
        >
          <img
            class="img-hand"
            [src]="getImageFromQuickTipsSprite('55_hand@2x')"
          />
          <div class="handTextstyle hand-55" [resizeText]="22">
            {{ currentQuickTipsID }}
          </div>
        </div>
        <div
          class="hand-container-55 id-91-2-he"
          [ngStyle]="{
            display:
              language == 'he' &&
              (currentQuickTipsID == 91 || currentQuickTipsID == 92)
                ? 'block'
                : 'none'
          }"
        >
          <img
            class="img-hand"
            [src]="getImageFromQuickTipsSprite('55_hand@2x')"
          />
          <div class="handTextstyle hand-55" [resizeText]="22">
            {{ currentQuickTipsID }}
          </div>
        </div>
        <div
          class="hand-container-52 id-91-1-hy"
          [ngStyle]="{
            display:
              language == 'hy' &&
              (currentQuickTipsID == 91 || currentQuickTipsID == 92)
                ? 'block'
                : 'none'
          }"
        >
          <img
            class="img-hand"
            [src]="getImageFromQuickTipsSprite('52_hand@2x')"
          />
          <div class="handTextstyle hand-52" [resizeText]="22">
            {{ currentQuickTipsID }}
          </div>
        </div>
        <div
          class="hand-container-52 id-91-2-hy"
          [ngStyle]="{
            display:
              language == 'hy' &&
              (currentQuickTipsID == 91 || currentQuickTipsID == 92)
                ? 'block'
                : 'none'
          }"
        >
          <img
            class="img-hand"
            [src]="getImageFromQuickTipsSprite('52_hand@2x')"
          />
          <div class="handTextstyle hand-52" [resizeText]="22">
            {{ currentQuickTipsID }}
          </div>
        </div>
        <div
          class="hand-container-52 id-91-1-vi"
          [ngStyle]="{
            display:
              language == 'vi' &&
              (currentQuickTipsID == 91 || currentQuickTipsID == 92)
                ? 'block'
                : 'none'
          }"
        >
          <img
            class="img-hand"
            [src]="getImageFromQuickTipsSprite('52_hand@2x')"
          />
          <div class="handTextstyle hand-52" [resizeText]="22">
            {{ currentQuickTipsID }}
          </div>
        </div>
        <div
          class="hand-container-52 id-91-2-vi"
          [ngStyle]="{
            display:
              language == 'vi' &&
              (currentQuickTipsID == 91 || currentQuickTipsID == 92)
                ? 'block'
                : 'none'
          }"
        >
          <img
            class="img-hand"
            [src]="getImageFromQuickTipsSprite('52_hand@2x')"
          />
          <div class="handTextstyle hand-52" [resizeText]="22">
            {{ currentQuickTipsID }}
          </div>
        </div>
        <div
          class="hand-container-52 id-91-1-ua"
          [ngStyle]="{
            display:
              language == 'ua' &&
              (currentQuickTipsID == 91 || currentQuickTipsID == 92)
                ? 'block'
                : 'none'
          }"
        >
          <img
            class="img-hand"
            [src]="getImageFromQuickTipsSprite('52_hand@2x')"
          />
          <div class="handTextstyle hand-52" [resizeText]="22">
            {{ currentQuickTipsID }}
          </div>
        </div>
        <div
          class="hand-container-52 id-91-2-ua"
          [ngStyle]="{
            display:
              language == 'ua' &&
              (currentQuickTipsID == 91 || currentQuickTipsID == 92)
                ? 'block'
                : 'none'
          }"
        >
          <img
            class="img-hand"
            [src]="getImageFromQuickTipsSprite('52_hand@2x')"
          />
          <div class="handTextstyle hand-52" [resizeText]="22">
            {{ currentQuickTipsID }}
          </div>
        </div>
        <div
          class="hand-container-52 id-91-1-tr"
          [ngStyle]="{
            display:
              language == 'tr' &&
              (currentQuickTipsID == 91 || currentQuickTipsID == 92)
                ? 'block'
                : 'none'
          }"
        >
          <img
            class="img-hand"
            [src]="getImageFromQuickTipsSprite('52_hand@2x')"
          />
          <div class="handTextstyle hand-52" [resizeText]="22">
            {{ currentQuickTipsID }}
          </div>
        </div>
        <div
          class="hand-container-52 id-91-2-tr"
          [ngStyle]="{
            display:
              language == 'tr' &&
              (currentQuickTipsID == 91 || currentQuickTipsID == 92)
                ? 'block'
                : 'none'
          }"
        >
          <img
            class="img-hand"
            [src]="getImageFromQuickTipsSprite('52_hand@2x')"
          />
          <div class="handTextstyle hand-52" [resizeText]="22">
            {{ currentQuickTipsID }}
          </div>
        </div>
        <div
          class="hand-container-52 id-91-1-th"
          [ngStyle]="{
            display:
              language == 'th' &&
              (currentQuickTipsID == 91 || currentQuickTipsID == 92)
                ? 'block'
                : 'none'
          }"
        >
          <img
            class="img-hand"
            [src]="getImageFromQuickTipsSprite('52_hand@2x')"
          />
          <div class="handTextstyle hand-52" [resizeText]="22">
            {{ currentQuickTipsID }}
          </div>
        </div>
        <div
          class="hand-container-52 id-91-2-th"
          [ngStyle]="{
            display:
              language == 'th' &&
              (currentQuickTipsID == 91 || currentQuickTipsID == 92)
                ? 'block'
                : 'none'
          }"
        >
          <img
            class="img-hand"
            [src]="getImageFromQuickTipsSprite('52_hand@2x')"
          />
          <div class="handTextstyle hand-52" [resizeText]="22">
            {{ currentQuickTipsID }}
          </div>
        </div>
        <div
          class="hand-container-55 id-91-1-ta-IN"
          [ngStyle]="{
            display:
              language == 'ta-IN' &&
              (currentQuickTipsID == 91 || currentQuickTipsID == 92)
                ? 'block'
                : 'none'
          }"
        >
          <img
            class="img-hand"
            [src]="getImageFromQuickTipsSprite('55_hand@2x')"
          />
          <div class="handTextstyle hand-55" [resizeText]="22">
            {{ currentQuickTipsID }}
          </div>
        </div>
        <div
          class="hand-container-55 id-91-2-ta-IN"
          [ngStyle]="{
            display:
              language == 'ta-IN' &&
              (currentQuickTipsID == 91 || currentQuickTipsID == 92)
                ? 'block'
                : 'none'
          }"
        >
          <img
            class="img-hand"
            [src]="getImageFromQuickTipsSprite('55_hand@2x')"
          />
          <div class="handTextstyle hand-55" [resizeText]="22">
            {{ currentQuickTipsID }}
          </div>
        </div>
        <div
          class="hand-container-52 id-91-1-sv"
          [ngStyle]="{
            display:
              language == 'sv' &&
              (currentQuickTipsID == 91 || currentQuickTipsID == 92)
                ? 'block'
                : 'none'
          }"
        >
          <img
            class="img-hand"
            [src]="getImageFromQuickTipsSprite('52_hand@2x')"
          />
          <div class="handTextstyle hand-52" [resizeText]="22">
            {{ currentQuickTipsID }}
          </div>
        </div>
        <div
          class="hand-container-52 id-91-2-sv"
          [ngStyle]="{
            display:
              language == 'sv' &&
              (currentQuickTipsID == 91 || currentQuickTipsID == 92)
                ? 'block'
                : 'none'
          }"
        >
          <img
            class="img-hand"
            [src]="getImageFromQuickTipsSprite('52_hand@2x')"
          />
          <div class="handTextstyle hand-52" [resizeText]="22">
            {{ currentQuickTipsID }}
          </div>
        </div>
        <div
          class="hand-container-52 id-91-1-si"
          [ngStyle]="{
            display:
              language == 'si' &&
              (currentQuickTipsID == 91 || currentQuickTipsID == 92)
                ? 'block'
                : 'none'
          }"
        >
          <img
            class="img-hand"
            [src]="getImageFromQuickTipsSprite('52_hand@2x')"
          />
          <div class="handTextstyle hand-52" [resizeText]="22">
            {{ currentQuickTipsID }}
          </div>
        </div>
        <div
          class="hand-container-52 id-91-2-si"
          [ngStyle]="{
            display:
              language == 'si' &&
              (currentQuickTipsID == 91 || currentQuickTipsID == 92)
                ? 'block'
                : 'none'
          }"
        >
          <img
            class="img-hand"
            [src]="getImageFromQuickTipsSprite('52_hand@2x')"
          />
          <div class="handTextstyle hand-52" [resizeText]="22">
            {{ currentQuickTipsID }}
          </div>
        </div>
        <div
          class="hand-container-52 id-91-1-sk"
          [ngStyle]="{
            display:
              language == 'sk' &&
              (currentQuickTipsID == 91 || currentQuickTipsID == 92)
                ? 'block'
                : 'none'
          }"
        >
          <img
            class="img-hand"
            [src]="getImageFromQuickTipsSprite('52_hand@2x')"
          />
          <div class="handTextstyle hand-52" [resizeText]="22">
            {{ currentQuickTipsID }}
          </div>
        </div>
        <div
          class="hand-container-52 id-91-2-sk"
          [ngStyle]="{
            display:
              language == 'sk' &&
              (currentQuickTipsID == 91 || currentQuickTipsID == 92)
                ? 'block'
                : 'none'
          }"
        >
          <img
            class="img-hand"
            [src]="getImageFromQuickTipsSprite('52_hand@2x')"
          />
          <div class="handTextstyle hand-52" [resizeText]="22">
            {{ currentQuickTipsID }}
          </div>
        </div>
        <div
          class="hand-container-52 id-91-1-sr-RS"
          [ngStyle]="{
            display:
              language == 'sr-RS' &&
              (currentQuickTipsID == 91 || currentQuickTipsID == 92)
                ? 'block'
                : 'none'
          }"
        >
          <img
            class="img-hand"
            [src]="getImageFromQuickTipsSprite('52_hand@2x')"
          />
          <div class="handTextstyle hand-52" [resizeText]="22">
            {{ currentQuickTipsID }}
          </div>
        </div>
        <div
          class="hand-container-52 id-91-2-sr-RS"
          [ngStyle]="{
            display:
              language == 'sr-RS' &&
              (currentQuickTipsID == 91 || currentQuickTipsID == 92)
                ? 'block'
                : 'none'
          }"
        >
          <img
            class="img-hand"
            [src]="getImageFromQuickTipsSprite('52_hand@2x')"
          />
          <div class="handTextstyle hand-52" [resizeText]="22">
            {{ currentQuickTipsID }}
          </div>
        </div>
        <div
          class="hand-container-52 id-91-1-ru"
          [ngStyle]="{
            display:
              language == 'ru' &&
              (currentQuickTipsID == 91 || currentQuickTipsID == 92)
                ? 'block'
                : 'none'
          }"
        >
          <img
            class="img-hand"
            [src]="getImageFromQuickTipsSprite('52_hand@2x')"
          />
          <div class="handTextstyle hand-52" [resizeText]="22">
            {{ currentQuickTipsID }}
          </div>
        </div>
        <div
          class="hand-container-52 id-91-2-ru"
          [ngStyle]="{
            display:
              language == 'ru' &&
              (currentQuickTipsID == 91 || currentQuickTipsID == 92)
                ? 'block'
                : 'none'
          }"
        >
          <img
            class="img-hand"
            [src]="getImageFromQuickTipsSprite('52_hand@2x')"
          />
          <div class="handTextstyle hand-52" [resizeText]="22">
            {{ currentQuickTipsID }}
          </div>
        </div>
        <div
          class="hand-container-52 id-91-1-ro"
          [ngStyle]="{
            display:
              language == 'ro' &&
              (currentQuickTipsID == 91 || currentQuickTipsID == 92)
                ? 'block'
                : 'none'
          }"
        >
          <img
            class="img-hand"
            [src]="getImageFromQuickTipsSprite('52_hand@2x')"
          />
          <div class="handTextstyle hand-52" [resizeText]="22">
            {{ currentQuickTipsID }}
          </div>
        </div>
        <div
          class="hand-container-52 id-91-2-ro"
          [ngStyle]="{
            display:
              language == 'ro' &&
              (currentQuickTipsID == 91 || currentQuickTipsID == 92)
                ? 'block'
                : 'none'
          }"
        >
          <img
            class="img-hand"
            [src]="getImageFromQuickTipsSprite('52_hand@2x')"
          />
          <div class="handTextstyle hand-52" [resizeText]="22">
            {{ currentQuickTipsID }}
          </div>
        </div>
        <div
          class="hand-container-52 id-91-1-pt-BR"
          [ngStyle]="{
            display:
              language == 'pt-BR' &&
              (currentQuickTipsID == 91 || currentQuickTipsID == 92)
                ? 'block'
                : 'none'
          }"
        >
          <img
            class="img-hand"
            [src]="getImageFromQuickTipsSprite('52_hand@2x')"
          />
          <div class="handTextstyle hand-52" [resizeText]="22">
            {{ currentQuickTipsID }}
          </div>
        </div>
        <div
          class="hand-container-52 id-91-2-pt-BR"
          [ngStyle]="{
            display:
              language == 'pt-BR' &&
              (currentQuickTipsID == 91 || currentQuickTipsID == 92)
                ? 'block'
                : 'none'
          }"
        >
          <img
            class="img-hand"
            [src]="getImageFromQuickTipsSprite('52_hand@2x')"
          />
          <div class="handTextstyle hand-52" [resizeText]="22">
            {{ currentQuickTipsID }}
          </div>
        </div>
        <div
          class="hand-container-52 id-91-1-pl"
          [ngStyle]="{
            display:
              language == 'pl' &&
              (currentQuickTipsID == 91 || currentQuickTipsID == 92)
                ? 'block'
                : 'none'
          }"
        >
          <img
            class="img-hand"
            [src]="getImageFromQuickTipsSprite('52_hand@2x')"
          />
          <div class="handTextstyle hand-52" [resizeText]="22">
            {{ currentQuickTipsID }}
          </div>
        </div>
        <div
          class="hand-container-52 id-91-2-pl"
          [ngStyle]="{
            display:
              language == 'pl' &&
              (currentQuickTipsID == 91 || currentQuickTipsID == 92)
                ? 'block'
                : 'none'
          }"
        >
          <img
            class="img-hand"
            [src]="getImageFromQuickTipsSprite('52_hand@2x')"
          />
          <div class="handTextstyle hand-52" [resizeText]="22">
            {{ currentQuickTipsID }}
          </div>
        </div>
        <div
          class="hand-container-52 id-91-1-nb"
          [ngStyle]="{
            display:
              language == 'nb' &&
              (currentQuickTipsID == 91 || currentQuickTipsID == 92)
                ? 'block'
                : 'none'
          }"
        >
          <img
            class="img-hand"
            [src]="getImageFromQuickTipsSprite('52_hand@2x')"
          />
          <div class="handTextstyle hand-52" [resizeText]="22">
            {{ currentQuickTipsID }}
          </div>
        </div>
        <div
          class="hand-container-52 id-91-2-nb"
          [ngStyle]="{
            display:
              language == 'nb' &&
              (currentQuickTipsID == 91 || currentQuickTipsID == 92)
                ? 'block'
                : 'none'
          }"
        >
          <img
            class="img-hand"
            [src]="getImageFromQuickTipsSprite('52_hand@2x')"
          />
          <div class="handTextstyle hand-52" [resizeText]="22">
            {{ currentQuickTipsID }}
          </div>
        </div>
        <div
          class="hand-container-55 id-91-1-mt"
          [ngStyle]="{
            display:
              language == 'mt' &&
              (currentQuickTipsID == 91 || currentQuickTipsID == 92)
                ? 'block'
                : 'none'
          }"
        >
          <img
            class="img-hand"
            [src]="getImageFromQuickTipsSprite('55_hand@2x')"
          />
          <div class="handTextstyle hand-55" [resizeText]="22">
            {{ currentQuickTipsID }}
          </div>
        </div>
        <div
          class="hand-container-55 id-91-2-mt"
          [ngStyle]="{
            display:
              language == 'mt' &&
              (currentQuickTipsID == 91 || currentQuickTipsID == 92)
                ? 'block'
                : 'none'
          }"
        >
          <img
            class="img-hand"
            [src]="getImageFromQuickTipsSprite('55_hand@2x')"
          />
          <div class="handTextstyle hand-55" [resizeText]="22">
            {{ currentQuickTipsID }}
          </div>
        </div>
        <div
          class="hand-container-52 id-91-1-my"
          [ngStyle]="{
            display:
              language == 'my' &&
              (currentQuickTipsID == 91 || currentQuickTipsID == 92)
                ? 'block'
                : 'none'
          }"
        >
          <img
            class="img-hand"
            [src]="getImageFromQuickTipsSprite('52_hand@2x')"
          />
          <div class="handTextstyle hand-52" [resizeText]="22">
            {{ currentQuickTipsID }}
          </div>
        </div>
        <div
          class="hand-container-52 id-91-2-my"
          [ngStyle]="{
            display:
              language == 'my' &&
              (currentQuickTipsID == 91 || currentQuickTipsID == 92)
                ? 'block'
                : 'none'
          }"
        >
          <img
            class="img-hand"
            [src]="getImageFromQuickTipsSprite('52_hand@2x')"
          />
          <div class="handTextstyle hand-52" [resizeText]="22">
            {{ currentQuickTipsID }}
          </div>
        </div>
        <div
          class="hand-container-52 id-91-1-lv"
          [ngStyle]="{
            display:
              language == 'lv' &&
              (currentQuickTipsID == 91 || currentQuickTipsID == 92)
                ? 'block'
                : 'none'
          }"
        >
          <img
            class="img-hand"
            [src]="getImageFromQuickTipsSprite('52_hand@2x')"
          />
          <div class="handTextstyle hand-52" [resizeText]="22">
            {{ currentQuickTipsID }}
          </div>
        </div>
        <div
          class="hand-container-52 id-91-2-lv"
          [ngStyle]="{
            display:
              language == 'lv' &&
              (currentQuickTipsID == 91 || currentQuickTipsID == 92)
                ? 'block'
                : 'none'
          }"
        >
          <img
            class="img-hand"
            [src]="getImageFromQuickTipsSprite('52_hand@2x')"
          />
          <div class="handTextstyle hand-52" [resizeText]="22">
            {{ currentQuickTipsID }}
          </div>
        </div>
        <div
          class="hand-container-55 id-91-1-lt"
          [ngStyle]="{
            display:
              language == 'lt' &&
              (currentQuickTipsID == 91 || currentQuickTipsID == 92)
                ? 'block'
                : 'none'
          }"
        >
          <img
            class="img-hand"
            [src]="getImageFromQuickTipsSprite('55_hand@2x')"
          />
          <div class="handTextstyle hand-55" [resizeText]="22">
            {{ currentQuickTipsID }}
          </div>
        </div>
        <div
          class="hand-container-55 id-91-2-lt"
          [ngStyle]="{
            display:
              language == 'lt' &&
              (currentQuickTipsID == 91 || currentQuickTipsID == 92)
                ? 'block'
                : 'none'
          }"
        >
          <img
            class="img-hand"
            [src]="getImageFromQuickTipsSprite('55_hand@2x')"
          />
          <div class="handTextstyle hand-55" [resizeText]="22">
            {{ currentQuickTipsID }}
          </div>
        </div>
        <div
          class="hand-container-52 id-91-1-ko"
          [ngStyle]="{
            display:
              language == 'ko' &&
              (currentQuickTipsID == 91 || currentQuickTipsID == 92)
                ? 'block'
                : 'none'
          }"
        >
          <img
            class="img-hand"
            [src]="getImageFromQuickTipsSprite('52_hand@2x')"
          />
          <div class="handTextstyle hand-52" [resizeText]="22">
            {{ currentQuickTipsID }}
          </div>
        </div>
        <div
          class="hand-container-52 id-91-2-ko"
          [ngStyle]="{
            display:
              language == 'ko' &&
              (currentQuickTipsID == 91 || currentQuickTipsID == 92)
                ? 'block'
                : 'none'
          }"
        >
          <img
            class="img-hand"
            [src]="getImageFromQuickTipsSprite('52_hand@2x')"
          />
          <div class="handTextstyle hand-52" [resizeText]="22">
            {{ currentQuickTipsID }}
          </div>
        </div>
        <div
          class="hand-container-52 id-91-1-ja"
          [ngStyle]="{
            display:
              language == 'ja' &&
              (currentQuickTipsID == 91 || currentQuickTipsID == 92)
                ? 'block'
                : 'none'
          }"
        >
          <img
            class="img-hand"
            [src]="getImageFromQuickTipsSprite('52_hand@2x')"
          />
          <div class="handTextstyle hand-52" [resizeText]="22">
            {{ currentQuickTipsID }}
          </div>
        </div>
        <div
          class="hand-container-52 id-91-2-ja"
          [ngStyle]="{
            display:
              language == 'ja' &&
              (currentQuickTipsID == 91 || currentQuickTipsID == 92)
                ? 'block'
                : 'none'
          }"
        >
          <img
            class="img-hand"
            [src]="getImageFromQuickTipsSprite('52_hand@2x')"
          />
          <div class="handTextstyle hand-52" [resizeText]="22">
            {{ currentQuickTipsID }}
          </div>
        </div>
        <div
          class="hand-container-52 id-91-1-it"
          [ngStyle]="{
            display:
              language == 'it' &&
              (currentQuickTipsID == 91 || currentQuickTipsID == 92)
                ? 'block'
                : 'none'
          }"
        >
          <img
            class="img-hand"
            [src]="getImageFromQuickTipsSprite('52_hand@2x')"
          />
          <div class="handTextstyle hand-52" [resizeText]="22">
            {{ currentQuickTipsID }}
          </div>
        </div>
        <div
          class="hand-container-52 id-91-2-it"
          [ngStyle]="{
            display:
              language == 'it' &&
              (currentQuickTipsID == 91 || currentQuickTipsID == 92)
                ? 'block'
                : 'none'
          }"
        >
          <img
            class="img-hand"
            [src]="getImageFromQuickTipsSprite('52_hand@2x')"
          />
          <div class="handTextstyle hand-52" [resizeText]="22">
            {{ currentQuickTipsID }}
          </div>
        </div>
        <div
          class="hand-container-52 id-91-1-id"
          [ngStyle]="{
            display:
              language == 'id' &&
              (currentQuickTipsID == 91 || currentQuickTipsID == 92)
                ? 'block'
                : 'none'
          }"
        >
          <img
            class="img-hand"
            [src]="getImageFromQuickTipsSprite('52_hand@2x')"
          />
          <div class="handTextstyle hand-52" [resizeText]="22">
            {{ currentQuickTipsID }}
          </div>
        </div>
        <div
          class="hand-container-52 id-91-2-id"
          [ngStyle]="{
            display:
              language == 'id' &&
              (currentQuickTipsID == 91 || currentQuickTipsID == 92)
                ? 'block'
                : 'none'
          }"
        >
          <img
            class="img-hand"
            [src]="getImageFromQuickTipsSprite('52_hand@2x')"
          />
          <div class="handTextstyle hand-52" [resizeText]="22">
            {{ currentQuickTipsID }}
          </div>
        </div>
        <div
          class="hand-container-52 id-91-1-hu"
          [ngStyle]="{
            display:
              language == 'hu' &&
              (currentQuickTipsID == 91 || currentQuickTipsID == 92)
                ? 'block'
                : 'none'
          }"
        >
          <img
            class="img-hand"
            [src]="getImageFromQuickTipsSprite('52_hand@2x')"
          />
          <div class="handTextstyle hand-52" [resizeText]="22">
            {{ currentQuickTipsID }}
          </div>
        </div>
        <div
          class="hand-container-52 id-91-2-hu"
          [ngStyle]="{
            display:
              language == 'hu' &&
              (currentQuickTipsID == 91 || currentQuickTipsID == 92)
                ? 'block'
                : 'none'
          }"
        >
          <img
            class="img-hand"
            [src]="getImageFromQuickTipsSprite('52_hand@2x')"
          />
          <div class="handTextstyle hand-52" [resizeText]="22">
            {{ currentQuickTipsID }}
          </div>
        </div>
        <div
          class="hand-container-52 id-91-1-hi-IN"
          [ngStyle]="{
            display:
              language == 'hi-IN' &&
              (currentQuickTipsID == 91 || currentQuickTipsID == 92)
                ? 'block'
                : 'none'
          }"
        >
          <img
            class="img-hand"
            [src]="getImageFromQuickTipsSprite('52_hand@2x')"
          />
          <div class="handTextstyle hand-52" [resizeText]="22">
            {{ currentQuickTipsID }}
          </div>
        </div>
        <div
          class="hand-container-52 id-91-2-hi-IN"
          [ngStyle]="{
            display:
              language == 'hi-IN' &&
              (currentQuickTipsID == 91 || currentQuickTipsID == 92)
                ? 'block'
                : 'none'
          }"
        >
          <img
            class="img-hand"
            [src]="getImageFromQuickTipsSprite('52_hand@2x')"
          />
          <div class="handTextstyle hand-52" [resizeText]="22">
            {{ currentQuickTipsID }}
          </div>
        </div>
        <div
          class="hand-container-52 id-91-1-ph"
          [ngStyle]="{
            display:
              language == 'ph' &&
              (currentQuickTipsID == 91 || currentQuickTipsID == 92)
                ? 'block'
                : 'none'
          }"
        >
          <img
            class="img-hand"
            [src]="getImageFromQuickTipsSprite('52_hand@2x')"
          />
          <div class="handTextstyle hand-52" [resizeText]="22">
            {{ currentQuickTipsID }}
          </div>
        </div>
        <div
          class="hand-container-52 id-91-2-ph"
          [ngStyle]="{
            display:
              language == 'ph' &&
              (currentQuickTipsID == 91 || currentQuickTipsID == 92)
                ? 'block'
                : 'none'
          }"
        >
          <img
            class="img-hand"
            [src]="getImageFromQuickTipsSprite('52_hand@2x')"
          />
          <div class="handTextstyle hand-52" [resizeText]="22">
            {{ currentQuickTipsID }}
          </div>
        </div>
        <div
          class="hand-container-52 id-91-1-nl"
          [ngStyle]="{
            display:
              language == 'nl' &&
              (currentQuickTipsID == 91 || currentQuickTipsID == 92)
                ? 'block'
                : 'none'
          }"
        >
          <img
            class="img-hand"
            [src]="getImageFromQuickTipsSprite('52_hand@2x')"
          />
          <div class="handTextstyle hand-52" [resizeText]="22">
            {{ currentQuickTipsID }}
          </div>
        </div>
        <div
          class="hand-container-52 id-91-2-nl"
          [ngStyle]="{
            display:
              language == 'nl' &&
              (currentQuickTipsID == 91 || currentQuickTipsID == 92)
                ? 'block'
                : 'none'
          }"
        >
          <img
            class="img-hand"
            [src]="getImageFromQuickTipsSprite('52_hand@2x')"
          />
          <div class="handTextstyle hand-52" [resizeText]="22">
            {{ currentQuickTipsID }}
          </div>
        </div>
        <div
          class="hand-container-55 id-91-1-zh-Hant"
          [ngStyle]="{
            display:
              language == 'zh-Hant' &&
              (currentQuickTipsID == 91 || currentQuickTipsID == 92)
                ? 'block'
                : 'none'
          }"
        >
          <img
            class="img-hand"
            [src]="getImageFromQuickTipsSprite('55_hand@2x')"
          />
          <div class="handTextstyle hand-55" [resizeText]="22">
            {{ currentQuickTipsID }}
          </div>
        </div>
        <div
          class="hand-container-55 id-91-2-zh-Hant"
          [ngStyle]="{
            display:
              language == 'zh-Hant' &&
              (currentQuickTipsID == 91 || currentQuickTipsID == 92)
                ? 'block'
                : 'none'
          }"
        >
          <img
            class="img-hand"
            [src]="getImageFromQuickTipsSprite('55_hand@2x')"
          />
          <div class="handTextstyle hand-55" [resizeText]="22">
            {{ currentQuickTipsID }}
          </div>
        </div>
        <div
          class="hand-container-55 id-91-1-zh-Hans"
          [ngStyle]="{
            display:
              language == 'zh-Hans' &&
              (currentQuickTipsID == 91 || currentQuickTipsID == 92)
                ? 'block'
                : 'none'
          }"
        >
          <img
            class="img-hand"
            [src]="getImageFromQuickTipsSprite('55_hand@2x')"
          />
          <div class="handTextstyle hand-55" [resizeText]="22">
            {{ currentQuickTipsID }}
          </div>
        </div>
        <div
          class="hand-container-55 id-91-2-zh-Hans"
          [ngStyle]="{
            display:
              language == 'zh-Hans' &&
              (currentQuickTipsID == 91 || currentQuickTipsID == 92)
                ? 'block'
                : 'none'
          }"
        >
          <img
            class="img-hand"
            [src]="getImageFromQuickTipsSprite('55_hand@2x')"
          />
          <div class="handTextstyle hand-55" [resizeText]="22">
            {{ currentQuickTipsID }}
          </div>
        </div>
        <div
          class="hand-container-52 id-91-1-kh"
          [ngStyle]="{
            display:
              language == 'kh' &&
              (currentQuickTipsID == 91 || currentQuickTipsID == 92)
                ? 'block'
                : 'none'
          }"
        >
          <img
            class="img-hand"
            [src]="getImageFromQuickTipsSprite('52_hand@2x')"
          />
          <div class="handTextstyle hand-52" [resizeText]="22">
            {{ currentQuickTipsID }}
          </div>
        </div>
        <div
          class="hand-container-52 id-91-2-kh"
          [ngStyle]="{
            display:
              language == 'kh' &&
              (currentQuickTipsID == 91 || currentQuickTipsID == 92)
                ? 'block'
                : 'none'
          }"
        >
          <img
            class="img-hand"
            [src]="getImageFromQuickTipsSprite('52_hand@2x')"
          />
          <div class="handTextstyle hand-52" [resizeText]="22">
            {{ currentQuickTipsID }}
          </div>
        </div>
      </div>
      <div
        [ngStyle]="{
          display:
            tutorialCount == 16 && language != 'he' && language != 'ar'
              ? 'block'
              : 'none'
        }"
        class="dynamic-card-container translate-top-most"
      >
        <div
          class="hand-container-22 id-94"
          [ngStyle]="{
            display:
              currentQuickTipsID == 94 || currentQuickTipsID == 95
                ? 'block'
                : 'none'
          }"
        >
          <img
            class="img-hand"
            [src]="getImageFromQuickTipsSprite('22_hand@2x')"
          />
          <div class="handTextstyle hand-22" [resizeText]="22">
            {{ currentQuickTipsID }}
          </div>
        </div>
      </div>
      <div
        [ngStyle]="{
          display:
            tutorialCount == 16 && (language == 'he' || language == 'ar')
              ? 'block'
              : 'none'
        }"
        class="dynamic-card-container translate-top-most"
      >
        <div
          class="hand-container-92 id-94-ar"
          [ngStyle]="{
            display:
              currentQuickTipsID == 94 || currentQuickTipsID == 95
                ? 'block'
                : 'none'
          }"
        >
          <img
            class="img-hand"
            [src]="getImageFromQuickTipsSprite('92_hand@2x')"
          />
          <div class="handTextstyle hand-92" [resizeText]="22">
            {{ currentQuickTipsID }}
          </div>
        </div>
      </div>
      <div
        [ngStyle]="{
          display:
            tutorialCount == 17 && language != 'he' && language != 'ar'
              ? 'block'
              : 'none'
        }"
        class="dynamic-card-container translate-top-most"
      >
        <div
          class="hand-container-22 id-94"
          [ngStyle]="{
            display:
              currentQuickTipsID == 97 || currentQuickTipsID == 98
                ? 'block'
                : 'none'
          }"
        >
          <img
            class="img-hand"
            [src]="getImageFromQuickTipsSprite('22_hand@2x')"
          />
          <div class="handTextstyle hand-22" [resizeText]="22">
            {{ currentQuickTipsID }}
          </div>
        </div>
      </div>
      <div
        [ngStyle]="{
          display:
            tutorialCount == 17 && (language == 'he' || language == 'ar')
              ? 'block'
              : 'none'
        }"
        class="dynamic-card-container translate-top-most"
      >
        <div
          class="hand-container-92 id-94-ar"
          [ngStyle]="{
            display:
              currentQuickTipsID == 97 || currentQuickTipsID == 98
                ? 'block'
                : 'none'
          }"
        >
          <img
            class="img-hand"
            [src]="getImageFromQuickTipsSprite('92_hand@2x')"
          />
          <div class="handTextstyle hand-92" [resizeText]="22">
            {{ currentQuickTipsID }}
          </div>
        </div>
      </div>
      <img
        class="both closetutorial button translate-top-most"
        [ngStyle]="{
          visibility:
            this.display == 1 && isDisplayAllButtons ? 'visible' : 'hidden'
        }"
        src="assets/images/lobby_sprite_images/common/menu_sprite_images/close.webp"
        (click)="buttonClick('close')"
      />
      <img
        class="both hometutorial button translate-top-most"
        src="assets/images/lobby_sprite_images/common/menu_sprite_images/tutorial_home.webp"
        (click)="buttonClick('home')"
        [ngStyle]="{
          visibility:
            this.display == 1 && this.tutorialCount != 0 && isDisplayAllButtons
              ? 'visible'
              : 'hidden'
        }"
      />
      <img
        class="both lefttutorial button translate-top-most"
        src="assets/images/lobby_sprite_images/common/menu_sprite_images/left.webp"
        (click)="buttonClick('left')"
        [ngStyle]="{
          visibility:
            this.display == 1 && this.tutorialCount != 0 && isDisplayAllButtons
              ? 'visible'
              : 'hidden'
        }"
      />
      <img
        class="both righttutorial button translate-top-most"
        src="assets/images/lobby_sprite_images/common/menu_sprite_images/right.webp"
        (click)="buttonClick('right')"
        [ngStyle]="{
          visibility:
            this.display == 1 && isDisplayAllButtons ? 'visible' : 'hidden'
        }"
      />
      <div
        class="translate-top-most tnimage-inside-div"
        [ngStyle]="{
          visibility:
            this.display == 1 && this.tutorialCount == 0 && isDisplayAllButtons
              ? 'visible'
              : 'hidden'
        }"
      >
        <div
          class="both tutorialbuttonleft tutorialbutton1 tutorial translate-top-most"
          (click)="tutorialClick(0)"
        ></div>
        <div
          class="both tutorialbuttonleft tutorialbutton2 tutorial translate-top-most"
          (click)="tutorialClick(1)"
        ></div>
        <div
          class="both tutorialbuttonleft tutorialbutton3 tutorial translate-top-most"
          (click)="tutorialClick(2)"
        ></div>
        <div
          class="both tutorialbuttonleft tutorialbutton4 tutorial translate-top-most"
          (click)="tutorialClick(3)"
        ></div>
        <div
          class="both tutorialbuttonleft tutorialbutton5 tutorial translate-top-most"
          (click)="tutorialClick(4)"
        ></div>
        <div
          class="both tutorialbuttonleft tutorialbutton6 tutorial translate-top-most"
          (click)="tutorialClick(5)"
        ></div>
        <div
          class="both tutorialbuttonleft tutorialbutton7 tutorial translate-top-most"
          (click)="tutorialClick(6)"
        ></div>
        <div
          class="both tutorialbuttonleft tutorialbutton8 tutorial translate-top-most"
          (click)="tutorialClick(7)"
        ></div>
        <div
          class="both tutorialbuttonleft tutorialbutton9 tutorial translate-top-most"
          (click)="tutorialClick(8)"
        ></div>

        <div
          class="both tutorialbuttonright tutorialbutton10 tutorial translate-top-most"
          (click)="tutorialClick(9)"
        ></div>
        <div
          class="both tutorialbuttonright tutorialbutton11 tutorial translate-top-most"
          (click)="tutorialClick(10)"
        ></div>
        <div
          class="both tutorialbuttonright tutorialbutton12 tutorial translate-top-most"
          (click)="tutorialClick(11)"
        ></div>
        <div
          class="both tutorialbuttonright tutorialbutton13 tutorial translate-top-most"
          (click)="tutorialClick(12)"
        ></div>
        <div
          class="both tutorialbuttonright tutorialbutton14 tutorial translate-top-most"
          (click)="tutorialClick(13)"
        ></div>
        <div
          class="both tutorialbuttonright tutorialbutton15 tutorial translate-top-most"
          (click)="tutorialClick(14)"
        ></div>
        <div
          class="both tutorialbuttonright tutorialbutton16 tutorial translate-top-most"
          (click)="tutorialClick(15)"
        ></div>
        <div
          class="both tutorialbuttonright tutorialbutton17 tutorial translate-top-most"
          (click)="tutorialClick(16)"
        ></div>
        <div
          class="both tutorialbuttonright tutorialbutton18 tutorial translate-top-most"
          (click)="tutorialClick(17)"
        ></div>
      </div>

      <!--below code are for showing payoff details-->
      <div
        class="translate-top-most"
        [ngStyle]="{
          visibility:
            pays_blank_tutorial['TN_pays_blank_position_' + tutorialCount]
              .length > 0 && isDisplayAllButtons
              ? 'visible'
              : 'hidden'
        }"
        *ngFor="
          let pays_blank_position of pays_blank_tutorial[
            'TN_pays_blank_position_' + tutorialCount
          ];
          let i = index
        "
      >
        <img
          [ngStyle]="{
            width: pays_blank_position.width * scaleR.scaleX + 'px',
            height: pays_blank_position.height * scaleR.scaleX + 'px',
            left:
              (tutorialCount === 18
                ? pays_blank_position.left[language] * scaleR.scaleX
                : pays_blank_position.left * scaleR.scaleX) + 'px',
            top: pays_blank_position.top * scaleR.scaleX + 'px',
            opacity: tutorialCount === 18 ? 0 : 1
          }"
          class="both button"
          src="assets/images/help/common/pays_blank_small@2x.webp"
        />
        <div
          class="pays_blank_small"
          [ngStyle]="{
            width: pays_blank_position.width * scaleR.scaleX + 'px',
            height: pays_blank_position.height * scaleR.scaleX + 'px',
            left:
              (tutorialCount === 18
                ? pays_blank_position.left[language] * scaleR.scaleX
                : pays_blank_position.left * scaleR.scaleX) + 'px',
            top: pays_blank_position.top * scaleR.scaleX + 'px',
            position: 'absolute'
          }"
        >
          <div
            [ngStyle]="{
              'font-size': paysContentFontSize * scaleR.scaleX + 'px',
              'font-family': paysContentFont,
              left: 0 * scaleR.scaleX + 'px',
              top: fontTranslationConst.paysContentTop * scaleR.scaleX + 'px',
              'letter-spacing':
                language == 'id' || language == 'ru' || language == 'sk'
                  ? -0.1 * scaleR.scaleX + 'px'
                  : 0 * scaleR.scaleX + 'px'
            }"
            class="pays-content"
          >
            {{ pays_blank_position.paysContent | translate }}
          </div>
          <div
            [ngStyle]="{
              'font-family': paysContentFont,
              'font-size': percentageContentFontSize * scaleR.scaleX + 'px',
              left: 0 * scaleR.scaleX + 'px',
              top:
                fontTranslationConst.percentageContentTop * scaleR.scaleX + 'px'
            }"
            class="pays-percentage-content"
          >
            {{ pays_blank_position.percentageContent }}
          </div>
        </div>
      </div>
    </div>
  </div>
  <div
    *ngIf="tutorialCount == 5 && language != 'he' && language != 'ar'"
    [resizeDom]="helpContentStageNoResizeChild"
    class="both helpbackground pointernone translate-top-most no-scroll-bar"
    [ngStyle]="{ visibility: display == 1 ? 'visible' : 'hidden' }"
  >
    <div class="dynamic-card-container translate-top-most">
      <div
        class="hand-container-5"
        [ngStyle]="{
          display:
            currentQuickTipsID == 77 && currentQuickTipsID != -1
              ? 'block'
              : 'none'
        }"
      >
        <img
          class="img-hand"
          [src]="getImageFromQuickTipsSprite('47_hand@2x')"
        />
        <div
          class="handTextstyle hand-47"
          [resizeText]="currentQuickTipsID <= 99 ? 22 : 20"
        >
          {{ currentQuickTipsID }}
        </div>
      </div>
    </div>
  </div>

  <div
    *ngIf="tutorialCount == 5 && (language == 'he' || language == 'ar')"
    style="pointer-events: none"
    [resizeDom]="helpContentStageNoResizeChild"
    class="both helpbackground pointernone translate-top-most no-scroll-bar"
    [ngStyle]="{ visibility: display == 1 ? 'visible' : 'hidden' }"
  >
    <div class="dynamic-card-container translate-top-most">
      <div
        class="hand-container-5-ar"
        [ngStyle]="{
          display:
            currentQuickTipsID == 77 && currentQuickTipsID != -1
              ? 'block'
              : 'none'
        }"
      >
        <img
          class="img-hand"
          [src]="getImageFromQuickTipsSprite('57_hand@2x')"
        />
        <div class="handTextstyle hand-57" [resizeText]="22">
          {{ currentQuickTipsID }}
        </div>
      </div>
    </div>
  </div>

  <div
    *ngIf="tutorialCount == 12 && language != 'he' && language != 'ar'"
    [resizeDom]="helpContentStageNoResizeChild"
    class="both helpbackground pointernone translate-top-most no-scroll-bar"
    [ngStyle]="{ visibility: display == 1 ? 'visible' : 'hidden' }"
  >
    <div class="dynamic-card-container translate-top-most">
      <div
        class="hand-container-5"
        [ngStyle]="{
          width: 62 * scaleR.scaleX + 'px',
          height: 69 * scaleR.scaleX + 'px',
          top: 62 * scaleR.scaleX + 'px',
          left: 92 * scaleR.scaleX + 'px',
          display:
            currentQuickTipsID == 84 && currentQuickTipsID != -1
              ? 'block'
              : 'none'
        }"
      >
        <img
          class="img-hand"
          [src]="getImageFromQuickTipsSprite('47_hand@2x')"
        />
        <div
          class="handTextstyle hand-47"
          [ngStyle]="{
            width: 34 * scaleR.scaleX + 'px',
            top: 11 * scaleR.scaleX + 'px',
            left: 4 * scaleR.scaleX + 'px' ? 'block' : 'none'
          }"
          [resizeText]="currentQuickTipsID <= 99 ? 22 : 20"
        >
          {{ currentQuickTipsID }}
        </div>
      </div>
    </div>
  </div>

  <div
    *ngIf="tutorialCount == 12 && (language == 'he' || language == 'ar')"
    style="pointer-events: none"
    [resizeDom]="helpContentStageNoResizeChild"
    class="both helpbackground pointernone translate-top-most no-scroll-bar"
    [ngStyle]="{ visibility: display == 1 ? 'visible' : 'hidden' }"
  >
    <div class="dynamic-card-container translate-top-most">
      <div
        class="hand-container-5-ar"
        [ngStyle]="{
          width: 62 * scaleR.scaleX + 'px',
          height: 78 * scaleR.scaleX + 'px',
          top: 62 * scaleR.scaleX + 'px',
          left: 650 * scaleR.scaleX + 'px',
          display:
            currentQuickTipsID == 84 && currentQuickTipsID != -1
              ? 'block'
              : 'none'
        }"
      >
        <img
          class="img-hand"
          [src]="getImageFromQuickTipsSprite('57_hand@2x')"
        />
        <div
          class="handTextstyle hand-57"
          [ngStyle]="{
            width: 34 * scaleR.scaleX + 'px',
            top: 14 * scaleR.scaleX + 'px',
            left: 4 * scaleR.scaleX + 'px' ? 'block' : 'none'
          }"
          [resizeText]="22"
        >
          {{ currentQuickTipsID }}
        </div>
      </div>
    </div>
  </div>

  <div
    *ngIf="tutorialCount == 13 && display == 1"
    [resizeDom]="helpContentStageNoResizeChild"
    class="both helpbackground pointernone translate-top-most no-scroll-bar"
  >
    <img
      class="translate-top-most both pointernone card-left-13"
      src="./assets/images/help/common/green_5.webp"
      [ngStyle]="{
        width:
          splittopcardsposition[language].splitCardWidth * scaleR.scaleX + 'px',
        height:
          splittopcardsposition[language].splitCardHeight * scaleR.scaleX +
          'px',
        top:
          splittopcardsposition[language].splitCard1Top * scaleR.scaleX + 'px',
        left:
          splittopcardsposition[language].splitCard1Left * scaleR.scaleX + 'px'
      }"
    />
    <img
      class="translate-top-most both pointernone card-right-13"
      src="./assets/images/help/common/blue_5.webp"
      [ngStyle]="{
        width:
          splittopcardsposition[language].splitCardWidth * scaleR.scaleX + 'px',
        height:
          splittopcardsposition[language].splitCardHeight * scaleR.scaleX +
          'px',
        top:
          splittopcardsposition[language].splitCard2Top * scaleR.scaleX + 'px',
        left:
          splittopcardsposition[language].splitCard2Left * scaleR.scaleX + 'px'
      }"
    />

    <img
      class="translate-top-most both pointernone card-left-13"
      src="./assets/images/help/common/green_5.webp"
      [ngStyle]="{
        width:
          splittopcardsposition[language].splitCardWidth * scaleR.scaleX + 'px',
        height:
          splittopcardsposition[language].splitCardHeight * scaleR.scaleX +
          'px',
        top:
          splittopcardsposition[language].splitCard1Top * scaleR.scaleX + 'px',
        left:
          splittopcardsposition[language].splitCard3Left * scaleR.scaleX + 'px'
      }"
    />
    <img
      class="translate-top-most both pointernone card-left-13"
      src="./assets/images/help/common/blue_5.webp"
      [ngStyle]="{
        width:
          splittopcardsposition[language].splitCardWidth * scaleR.scaleX + 'px',
        height:
          splittopcardsposition[language].splitCardHeight * scaleR.scaleX +
          'px',
        top:
          splittopcardsposition[language].splitCard2Top * scaleR.scaleX + 'px',
        left:
          splittopcardsposition[language].splitCard4Left * scaleR.scaleX + 'px'
      }"
    />

    <img
      class="translate-top-most both pointernone"
      [src]="
        'assets/images/help/common/' +
        (language == 'ar' || language == 'he'
          ? 'split_top_cards_rtl@2x@2x.webp'
          : 'split_top_cards@2x.webp')
      "
      [ngStyle]="{
        width: splittopcardsposition[language].width * scaleR.scaleX + 'px',
        height: splittopcardsposition[language].height * scaleR.scaleX + 'px',
        top: splittopcardsposition[language].top * scaleR.scaleX + 'px',
        left: splittopcardsposition[language].left * scaleR.scaleX + 'px'
      }"
    />
  </div>

  <div
    *ngIf="tutorialCount == 14 && display == 1"
    [resizeDom]="helpContentStageNoResizeChild"
    class="both helpbackground pointernone translate-top-most no-scroll-bar"
  >
    <img
      class="split-card card-left split-card-1"
      [ngStyle]="{
        width: 136 * scaleR.scaleX + 'px',
        height: 184 * scaleR.scaleX + 'px',
        top: splitcardsposition[language].cardTop * scaleR.scaleX + 'px',
        left: splitcardsposition[language].card1Left * scaleR.scaleX + 'px'
      }"
      src="./assets/images/help/common/green_11.webp"
    />
    <img
      class="split-card card-right split-card-2"
      [ngStyle]="{
        width: 136 * scaleR.scaleX + 'px',
        height: 184 * scaleR.scaleX + 'px',
        top: splitcardsposition[language].cardTop * scaleR.scaleX + 'px',
        left: splitcardsposition[language].card2Left * scaleR.scaleX + 'px'
      }"
      src="./assets/images/help/common/orange_11.webp"
    />
    <img
      class="split-card card-left split-card-3"
      [ngStyle]="{
        width: 136 * scaleR.scaleX + 'px',
        height: 184 * scaleR.scaleX + 'px',
        top: splitcardsposition[language].cardTop * scaleR.scaleX + 'px',
        left: splitcardsposition[language].card3Left * scaleR.scaleX + 'px'
      }"
      src="./assets/images/help/common/white_7.webp"
    />
    <img
      class="split-card card-right split-card-4"
      [ngStyle]="{
        width: 136 * scaleR.scaleX + 'px',
        height: 184 * scaleR.scaleX + 'px',
        top: splitcardsposition[language].cardTop * scaleR.scaleX + 'px',
        left: splitcardsposition[language].card4Left * scaleR.scaleX + 'px'
      }"
      src="./assets/images/help/common/white_7.webp"
    />
    <img
      class="split-card card-left split-card-5"
      [ngStyle]="{
        width: 136 * scaleR.scaleX + 'px',
        height: 184 * scaleR.scaleX + 'px',
        top: splitcardsposition[language].cardTop * scaleR.scaleX + 'px',
        left: splitcardsposition[language].card5Left * scaleR.scaleX + 'px'
      }"
      src="./assets/images/help/common/white_5.webp"
    />
    <img
      class="split-card card-right split-card-6"
      [ngStyle]="{
        width: 136 * scaleR.scaleX + 'px',
        height: 184 * scaleR.scaleX + 'px',
        top: splitcardsposition[language].cardTop * scaleR.scaleX + 'px',
        left: splitcardsposition[language].card6Left * scaleR.scaleX + 'px'
      }"
      src="./assets/images/help/common/blue_5.webp"
    />
  </div>

  <div
    *ngIf="tutorialCount == 18 && display == 1"
    [resizeDom]="helpContentStageNoResizeChild"
    class="both helpbackground pointernone translate-top-most no-scroll-bar"
  >
    <!--<img *ngIf="(currentQuickTipsID === 100 || currentQuickTipsID === 101) && currentQuickTipsID != -1 && rouletteScore == 17"
         [src]="getImageFromQuickTipsSprite('fc21_Tutorial_18_Russian_Roulette_hh_highlight@2x')"
         [ngStyle]="{'width': (rouletteposition[language].bgWidth * scaleR.scaleX) + 'px', 'height': (rouletteposition[language].bgHeight * scaleR.scaleX) + 'px', 'top': (rouletteposition[language].bgTop * scaleR.scaleX) + 'px', 'left': (rouletteposition[language].bg17Left * scaleR.scaleX) + 'px'}"
         class="both button rr-id rr-17-en">
    <img *ngIf="(currentQuickTipsID === 103 || currentQuickTipsID === 104) && currentQuickTipsID != -1 && rouletteScore == 18"
         [src]="getImageFromQuickTipsSprite('fc21_Tutorial_18_Russian_Roulette_hh_highlight@2x')"
         [ngStyle]="{'width': (rouletteposition[language].bgWidth * scaleR.scaleX) + 'px', 'height': (rouletteposition[language].bgHeight * scaleR.scaleX) + 'px', 'top': (rouletteposition[language].bgTop * scaleR.scaleX) + 'px', 'left': (rouletteposition[language].bg18Left * scaleR.scaleX) + 'px'}"
         class="both button rr-id rr-18-en">
    <img *ngIf="(currentQuickTipsID === 106 || currentQuickTipsID === 107) && currentQuickTipsID != -1 && rouletteScore == 19"
         [src]="getImageFromQuickTipsSprite('fc21_Tutorial_18_Russian_Roulette_hh_highlight@2x')"
         [ngStyle]="{'width': (rouletteposition[language].bgWidth * scaleR.scaleX) + 'px', 'height': (rouletteposition[language].bgHeight * scaleR.scaleX) + 'px', 'top': (rouletteposition[language].bgTop * scaleR.scaleX) + 'px', 'left': (rouletteposition[language].bg19Left * scaleR.scaleX) + 'px'}"
         class="both button rr-id rr-19-en">
    <img *ngIf="(currentQuickTipsID === 109 || currentQuickTipsID === 110) && currentQuickTipsID != -1 && rouletteScore == 20"
         [src]="getImageFromQuickTipsSprite('fc21_Tutorial_18_Russian_Roulette_hh_highlight@2x')"
         [ngStyle]="{'width': (rouletteposition[language].bgWidth * scaleR.scaleX) + 'px', 'height': (rouletteposition[language].bgHeight * scaleR.scaleX) + 'px', 'top': (rouletteposition[language].bgTop * scaleR.scaleX) + 'px', 'left': (rouletteposition[language].bg20Left * scaleR.scaleX) + 'px'}"
         class="both button rr-id rr-20-en">-->
    <div
      *ngIf="
        (currentQuickTipsID === 100 || currentQuickTipsID === 101) &&
        currentQuickTipsID != -1 &&
        rouletteScore == 17
      "
      class="hand-container-55 id-17-en"
      style="z-index: 2"
      [ngStyle]="{
        width:
          rouletteposition[language].handContainerWidth * scaleR.scaleX + 'px',
        height:
          rouletteposition[language].handContainerHeight * scaleR.scaleX + 'px',
        top: rouletteposition[language].handContainerTop * scaleR.scaleX + 'px',
        left:
          rouletteposition[language].handContainer17Left * scaleR.scaleX + 'px'
      }"
    >
      <img class="img-hand" [src]="getImageFromQuickTipsSprite('55_hand@2x')" />
      <div
        class="handTextstyle hand-55-1"
        [resizeText]="20"
        [ngStyle]="{
          width: 34 * scaleR.scaleX + 'px',
          top: 14 * scaleR.scaleX + 'px',
          left: 16 * scaleR.scaleX + 'px'
        }"
      >
        {{ currentQuickTipsID }}
      </div>
    </div>
    <div
      *ngIf="
        (currentQuickTipsID === 103 || currentQuickTipsID === 104) &&
        currentQuickTipsID != -1 &&
        rouletteScore == 18
      "
      class="hand-container-55 id-18-en"
      style="z-index: 2"
      [ngStyle]="{
        width:
          rouletteposition[language].handContainerWidth * scaleR.scaleX + 'px',
        height:
          rouletteposition[language].handContainerHeight * scaleR.scaleX + 'px',
        top: rouletteposition[language].handContainerTop * scaleR.scaleX + 'px',
        left:
          rouletteposition[language].handContainer18Left * scaleR.scaleX + 'px'
      }"
    >
      <img class="img-hand" [src]="getImageFromQuickTipsSprite('55_hand@2x')" />
      <div
        class="handTextstyle hand-55-1"
        [resizeText]="20"
        [ngStyle]="{
          width: 34 * scaleR.scaleX + 'px',
          top: 14 * scaleR.scaleX + 'px',
          left: 16 * scaleR.scaleX + 'px'
        }"
      >
        {{ currentQuickTipsID }}
      </div>
    </div>
    <div
      *ngIf="
        (currentQuickTipsID === 106 || currentQuickTipsID === 107) &&
        currentQuickTipsID != -1 &&
        rouletteScore == 19
      "
      class="hand-container-55 id-19-en"
      style="z-index: 2"
      [ngStyle]="{
        width:
          rouletteposition[language].handContainerWidth * scaleR.scaleX + 'px',
        height:
          rouletteposition[language].handContainerHeight * scaleR.scaleX + 'px',
        top: rouletteposition[language].handContainerTop * scaleR.scaleX + 'px',
        left:
          rouletteposition[language].handContainer19Left * scaleR.scaleX + 'px'
      }"
    >
      <img class="img-hand" [src]="getImageFromQuickTipsSprite('55_hand@2x')" />
      <div
        class="handTextstyle hand-55-1"
        [resizeText]="20"
        [ngStyle]="{
          width: 34 * scaleR.scaleX + 'px',
          top: 14 * scaleR.scaleX + 'px',
          left: 16 * scaleR.scaleX + 'px'
        }"
      >
        {{ currentQuickTipsID }}
      </div>
    </div>
    <div
      *ngIf="
        (currentQuickTipsID === 109 || currentQuickTipsID === 110) &&
        currentQuickTipsID != -1 &&
        rouletteScore == 20
      "
      class="hand-container-55 id-20-en"
      style="z-index: 2"
      [ngStyle]="{
        width:
          rouletteposition[language].handContainerWidth * scaleR.scaleX + 'px',
        height:
          rouletteposition[language].handContainerHeight * scaleR.scaleX + 'px',
        top: rouletteposition[language].handContainerTop * scaleR.scaleX + 'px',
        left:
          rouletteposition[language].handContainer20Left * scaleR.scaleX + 'px'
      }"
    >
      <img class="img-hand" [src]="getImageFromQuickTipsSprite('55_hand@2x')" />
      <div
        class="handTextstyle hand-55-1"
        [resizeText]="20"
        [ngStyle]="{
          width: 34 * scaleR.scaleX + 'px',
          top: 14 * scaleR.scaleX + 'px',
          left: 16 * scaleR.scaleX + 'px'
        }"
      >
        {{ currentQuickTipsID }}
      </div>
    </div>
  </div>
  <div
    *ngIf="display == 1 && tutorialCount == 21"
    [resizeDom]="quickKeysContentStageNoResizeChild"
    class="both helpbackground pointernone translate-top-most no-scroll-bar quick-keys-content"
  >
    <div
      class="both quick-keys-header quick-keys-text key-uppercase"
      [ngStyle]="{
        width:
          quickkeysheaderposition[language].headerWidth * scaleR.scaleX + 'px',
        height:
          quickkeysheaderposition[language].headerHeight * scaleR.scaleX + 'px',
        top: quickkeysheaderposition[language].headerTop * scaleR.scaleX + 'px',
        left:
          quickkeysheaderposition[language].headerLeft * scaleR.scaleX + 'px'
      }"
      [resizeText]="28"
    >
      {{ mapKeyConstant[language]['0'] }}
    </div>
    <div
      [ngStyle]="{
        width:
          quickkeysheaderposition[language].left3Width * scaleR.scaleX + 'px',
        height:
          quickkeysheaderposition[language].left3Height * scaleR.scaleX + 'px',
        top: quickkeysheaderposition[language].left3Top * scaleR.scaleX + 'px',
        left: quickkeysheaderposition[language].left3Left * scaleR.scaleX + 'px'
      }"
      class="both quick-keys-text key-uppercase"
      [resizeText]="quickkeysheaderposition[language].symbolResize"
    >
      {{ mapKeyConstant[language]['1'] }}
    </div>
    <div
      [ngStyle]="{
        width:
          quickkeysheaderposition[language].left4Width * scaleR.scaleX + 'px',
        height:
          quickkeysheaderposition[language].left4Height * scaleR.scaleX + 'px',
        top: quickkeysheaderposition[language].left4Top * scaleR.scaleX + 'px',
        left: quickkeysheaderposition[language].left4Left * scaleR.scaleX + 'px'
      }"
      class="both quick-keys-text key-uppercase"
      [resizeText]="quickkeysheaderposition[language].symbolResize"
    >
      {{ mapKeyConstant[language]['2'] }}
    </div>
    <div
      [ngStyle]="{
        width:
          quickkeysheaderposition[language].left5Width * scaleR.scaleX + 'px',
        height:
          quickkeysheaderposition[language].left5Height * scaleR.scaleX + 'px',
        top: quickkeysheaderposition[language].left5Top * scaleR.scaleX + 'px',
        left: quickkeysheaderposition[language].left5Left * scaleR.scaleX + 'px'
      }"
      class="both quick-keys-text key-uppercase"
      [resizeText]="quickkeysheaderposition[language].symbolResize"
    >
      {{ mapKeyConstant[language]['3'] }}
    </div>
    <div
      [ngStyle]="{
        width:
          quickkeysheaderposition[language].left6Width * scaleR.scaleX + 'px',
        height:
          quickkeysheaderposition[language].left6Height * scaleR.scaleX + 'px',
        top: quickkeysheaderposition[language].left6Top * scaleR.scaleX + 'px',
        left: quickkeysheaderposition[language].left6Left * scaleR.scaleX + 'px'
      }"
      class="both quick-keys-text key-uppercase"
      [resizeText]="quickkeysheaderposition[language].symbolResize"
    >
      {{ mapKeyConstant[language]['4'] }}
    </div>
    <div
      [ngStyle]="{
        width:
          quickkeysheaderposition[language].left7Width * scaleR.scaleX + 'px',
        height:
          quickkeysheaderposition[language].left7Height * scaleR.scaleX + 'px',
        top: quickkeysheaderposition[language].left7Top * scaleR.scaleX + 'px',
        left: quickkeysheaderposition[language].left7Left * scaleR.scaleX + 'px'
      }"
      class="both quick-keys-text key-uppercase"
      [resizeText]="quickkeysheaderposition[language].symbolResize"
    >
      {{ mapKeyConstant[language]['5'] }}
    </div>
    <div
      [ngStyle]="{
        width:
          quickkeysheaderposition[language].left8Width * scaleR.scaleX + 'px',
        height:
          quickkeysheaderposition[language].left8Height * scaleR.scaleX + 'px',
        top: quickkeysheaderposition[language].left8Top * scaleR.scaleX + 'px',
        left: quickkeysheaderposition[language].left8Left * scaleR.scaleX + 'px'
      }"
      class="both quick-keys-text key-uppercase"
      [resizeText]="quickkeysheaderposition[language].symbolResize"
    >
      {{ mapKeyConstant[language]['6'] }}
    </div>
    <div
      [ngStyle]="{
        width:
          quickkeysheaderposition[language].left9Width * scaleR.scaleX + 'px',
        height:
          quickkeysheaderposition[language].left9Height * scaleR.scaleX + 'px',
        top: quickkeysheaderposition[language].left9Top * scaleR.scaleX + 'px',
        left: quickkeysheaderposition[language].left9Left * scaleR.scaleX + 'px'
      }"
      class="both quick-keys-text key-uppercase"
      [resizeText]="quickkeysheaderposition[language].symbolResize"
    >
      {{ mapKeyConstant[language]['7'] }}
    </div>
    <div
      [ngStyle]="{
        width:
          quickkeysheaderposition[language].left10Width * scaleR.scaleX + 'px',
        height:
          quickkeysheaderposition[language].left10Height * scaleR.scaleX + 'px',
        top: quickkeysheaderposition[language].left10Top * scaleR.scaleX + 'px',
        left:
          quickkeysheaderposition[language].left10Left * scaleR.scaleX + 'px'
      }"
      class="both quick-keys-text key-uppercase"
      [resizeText]="quickkeysheaderposition[language].symbolResize"
    >
      {{ mapKeyConstant[language]['8'] }}
    </div>
    <div
      [ngStyle]="{
        width:
          quickkeysheaderposition[language].left11Width * scaleR.scaleX + 'px',
        height:
          quickkeysheaderposition[language].left11Height * scaleR.scaleX + 'px',
        top: quickkeysheaderposition[language].left11Top * scaleR.scaleX + 'px',
        left:
          quickkeysheaderposition[language].left11Left * scaleR.scaleX + 'px'
      }"
      class="both quick-keys-text key-uppercase"
      [resizeText]="quickkeysheaderposition[language].symbolResize"
    >
      {{ mapKeyConstant[language]['9'] }}
    </div>
    <div
      [ngStyle]="{
        width:
          quickkeysheaderposition[language].left12Width * scaleR.scaleX + 'px',
        height:
          quickkeysheaderposition[language].left12Height * scaleR.scaleX + 'px',
        top: quickkeysheaderposition[language].left12Top * scaleR.scaleX + 'px',
        left:
          quickkeysheaderposition[language].left12Left * scaleR.scaleX + 'px'
      }"
      class="both quick-keys-text key-uppercase"
      [resizeText]="quickkeysheaderposition[language].symbolResize"
    >
      {{ mapKeyConstant[language]['0'] }}
    </div>
    <div
      [ngStyle]="{
        width:
          quickkeysheaderposition[language].left13Width * scaleR.scaleX + 'px',
        height:
          quickkeysheaderposition[language].left13Height * scaleR.scaleX + 'px',
        top: quickkeysheaderposition[language].left13Top * scaleR.scaleX + 'px',
        left:
          quickkeysheaderposition[language].left13Left * scaleR.scaleX + 'px'
      }"
      class="both quick-keys-text key-uppercase"
      [resizeText]="quickkeysheaderposition[language].symbolResize"
    >
      {{ mapKeyConstant[language]['h'] }}
    </div>
    <div
      [ngStyle]="{
        width:
          quickkeysheaderposition[language].left14Width * scaleR.scaleX + 'px',
        height:
          quickkeysheaderposition[language].left14Height * scaleR.scaleX + 'px',
        top: quickkeysheaderposition[language].left14Top * scaleR.scaleX + 'px',
        left:
          quickkeysheaderposition[language].left14Left * scaleR.scaleX + 'px'
      }"
      class="both quick-keys-text key-uppercase"
      [resizeText]="quickkeysheaderposition[language].symbolResize"
    >
      {{ mapKeyConstant[language]['i'] }}
    </div>

    <div
      [ngStyle]="{
        width:
          quickkeysheaderposition[language].right1Width * scaleR.scaleX + 'px',
        height:
          quickkeysheaderposition[language].right1Height * scaleR.scaleX + 'px',
        top: quickkeysheaderposition[language].right1Top * scaleR.scaleX + 'px',
        left:
          quickkeysheaderposition[language].right1Left * scaleR.scaleX + 'px'
      }"
      class="both quick-keys-text key-uppercase"
      [resizeText]="quickkeysheaderposition[language].symbolResize"
    >
      {{ mapKeyConstant[language]['s'] }}
    </div>
    <div
      [ngStyle]="{
        width:
          quickkeysheaderposition[language].right2Width * scaleR.scaleX + 'px',
        height:
          quickkeysheaderposition[language].right2Height * scaleR.scaleX + 'px',
        top: quickkeysheaderposition[language].right2Top * scaleR.scaleX + 'px',
        left:
          quickkeysheaderposition[language].right2Left * scaleR.scaleX + 'px'
      }"
      class="both quick-keys-text key-uppercase"
      [resizeText]="quickkeysheaderposition[language].symbolResize"
    >
      {{ mapKeyConstant[language]['d'] }}
    </div>
    <div
      [ngStyle]="{
        width:
          quickkeysheaderposition[language].right3Width * scaleR.scaleX + 'px',
        height:
          quickkeysheaderposition[language].right3Height * scaleR.scaleX + 'px',
        top: quickkeysheaderposition[language].right3Top * scaleR.scaleX + 'px',
        left:
          quickkeysheaderposition[language].right3Left * scaleR.scaleX + 'px'
      }"
      class="both quick-keys-text key-uppercase"
      [resizeText]="quickkeysheaderposition[language].symbolResize"
    >
      {{ mapKeyConstant[language]['r'] }}
    </div>
    <div
      [ngStyle]="{
        width:
          quickkeysheaderposition[language].right4Width * scaleR.scaleX + 'px',
        height:
          quickkeysheaderposition[language].right4Height * scaleR.scaleX + 'px',
        top: quickkeysheaderposition[language].right4Top * scaleR.scaleX + 'px',
        left:
          quickkeysheaderposition[language].right4Left * scaleR.scaleX + 'px',
        'letter-spacing': quickkeysheaderposition[language].right4letterspacing
          ? quickkeysheaderposition[language].right4letterspacing + 'vw'
          : '0vw'
      }"
      class="both quick-keys-text key-uppercase"
      [resizeText]="quickkeysheaderposition[language].right4SymbolResize"
    >
      {{ mapKeyConstant[language]['c'] }}
    </div>
    <div
      [ngStyle]="{
        width:
          quickkeysheaderposition[language].right5Width * scaleR.scaleX + 'px',
        height:
          quickkeysheaderposition[language].right5Height * scaleR.scaleX + 'px',
        top: quickkeysheaderposition[language].right5Top * scaleR.scaleX + 'px',
        left:
          quickkeysheaderposition[language].right5Left * scaleR.scaleX + 'px'
      }"
      class="both quick-keys-text key-uppercase"
      [resizeText]="quickkeysheaderposition[language].symbolResize"
    >
      {{ mapKeyConstant[language]['y'] }}
    </div>
    <div
      [ngStyle]="{
        width:
          quickkeysheaderposition[language].right6Width * scaleR.scaleX + 'px',
        height:
          quickkeysheaderposition[language].right6Height * scaleR.scaleX + 'px',
        top: quickkeysheaderposition[language].right6Top * scaleR.scaleX + 'px',
        left:
          quickkeysheaderposition[language].right6Left * scaleR.scaleX + 'px'
      }"
      class="both quick-keys-text key-uppercase"
      [resizeText]="quickkeysheaderposition[language].symbolResize"
    >
      {{ mapKeyConstant[language]['n'] }}
    </div>
    <div
      [ngStyle]="{
        width:
          quickkeysheaderposition[language].right7Width * scaleR.scaleX + 'px',
        height:
          quickkeysheaderposition[language].right7Height * scaleR.scaleX + 'px',
        top: quickkeysheaderposition[language].right7Top * scaleR.scaleX + 'px',
        left:
          quickkeysheaderposition[language].right7Left * scaleR.scaleX + 'px'
      }"
      class="both quick-keys-text key-uppercase"
      [resizeText]="quickkeysheaderposition[language].right4SymbolResize"
    >
      {{ mapKeyConstant[language]['x'] }}
    </div>
    <div
      [ngStyle]="{
        width:
          quickkeysheaderposition[language].right8Width * scaleR.scaleX + 'px',
        height:
          quickkeysheaderposition[language].right8Height * scaleR.scaleX + 'px',
        top: quickkeysheaderposition[language].right8Top * scaleR.scaleX + 'px',
        left:
          quickkeysheaderposition[language].right8Left * scaleR.scaleX + 'px'
      }"
      class="both quick-keys-text"
      [resizeText]="quickkeysheaderposition[language].symbolResize"
    >
      {{ 'LANG00952' | translate }}
    </div>
    <div
      [ngStyle]="{
        width:
          quickkeysheaderposition[language].right9Width * scaleR.scaleX + 'px',
        height:
          quickkeysheaderposition[language].right9Height * scaleR.scaleX + 'px',
        top: quickkeysheaderposition[language].right9Top * scaleR.scaleX + 'px',
        left:
          quickkeysheaderposition[language].right9Left * scaleR.scaleX + 'px',
        'word-wrap': quickkeysheaderposition[language].wordwrap,
        'line-height':
          quickkeysheaderposition[language].lineHeight * scaleR.scaleX + 'px',
        'letter-spacing': quickkeysheaderposition[language].letterspacing + 'vw'
      }"
      class="both quick-keys-text"
      [resizeText]="quickkeysheaderposition[language].textResize"
    >
      {{ 'LANG00739' | translate }}
    </div>
    <div
      [ngStyle]="{
        width:
          quickkeysheaderposition[language].right10Width * scaleR.scaleX + 'px',
        height:
          quickkeysheaderposition[language].right10Height * scaleR.scaleX +
          'px',
        top:
          quickkeysheaderposition[language].right10Top * scaleR.scaleX + 'px',
        left:
          quickkeysheaderposition[language].right10Left * scaleR.scaleX + 'px',
        'word-wrap': quickkeysheaderposition[language].wordwrap,
        'line-height':
          quickkeysheaderposition[language].lineHeight * scaleR.scaleX + 'px',
        'letter-spacing': quickkeysheaderposition[language].letterspacing + 'vw'
      }"
      class="both quick-keys-text"
      [resizeText]="quickkeysheaderposition[language].textResize"
    >
      {{ 'LANG00739' | translate }}
    </div>
    <div
      [ngStyle]="{
        width:
          quickkeysheaderposition[language].right11Width * scaleR.scaleX + 'px',
        height:
          quickkeysheaderposition[language].right11Height * scaleR.scaleX +
          'px',
        top:
          quickkeysheaderposition[language].right11Top * scaleR.scaleX + 'px',
        left:
          quickkeysheaderposition[language].right11Left * scaleR.scaleX + 'px',
        'word-wrap': quickkeysheaderposition[language].wordwrap,
        'line-height':
          quickkeysheaderposition[language].lineHeight * scaleR.scaleX + 'px',
        'letter-spacing': quickkeysheaderposition[language].letterspacing + 'vw'
      }"
      class="both quick-keys-text"
      [resizeText]="quickkeysheaderposition[language].textResize"
    >
      {{ 'LANG00739' | translate }}
    </div>
    <div
      [ngStyle]="{
        width:
          quickkeysheaderposition[language].right12Width * scaleR.scaleX + 'px',
        height:
          quickkeysheaderposition[language].right12Height * scaleR.scaleX +
          'px',
        top:
          quickkeysheaderposition[language].right12Top * scaleR.scaleX + 'px',
        left:
          quickkeysheaderposition[language].right12Left * scaleR.scaleX + 'px',
        'word-wrap': quickkeysheaderposition[language].wordwrap,
        'line-height':
          quickkeysheaderposition[language].lineHeight * scaleR.scaleX + 'px',
        'letter-spacing': quickkeysheaderposition[language].letterspacing + 'vw'
      }"
      class="both quick-keys-text"
      [resizeText]="quickkeysheaderposition[language].textResize"
    >
      {{ 'LANG00739' | translate }}
    </div>
    <div
      [ngStyle]="{
        width:
          quickkeysheaderposition[language].right13Width * scaleR.scaleX + 'px',
        height:
          quickkeysheaderposition[language].right13Height * scaleR.scaleX +
          'px',
        top:
          quickkeysheaderposition[language].right13Top * scaleR.scaleX + 'px',
        left:
          quickkeysheaderposition[language].right13Left * scaleR.scaleX + 'px'
      }"
      class="both quick-keys-text key-uppercase"
      [resizeText]="quickkeysheaderposition[language].symbolResize"
    >
      {{ mapKeyConstant[language]['e'] }}
    </div>
    <div
      [ngStyle]="{
        width:
          quickkeysheaderposition[language].right14Width * scaleR.scaleX + 'px',
        height:
          quickkeysheaderposition[language].right14Height * scaleR.scaleX +
          'px',
        top:
          quickkeysheaderposition[language].right14Top * scaleR.scaleX + 'px',
        left:
          quickkeysheaderposition[language].right14Left * scaleR.scaleX + 'px'
      }"
      class="both quick-keys-text key-uppercase"
      [resizeText]="quickkeysheaderposition[language].symbolResize"
    >
      {{ mapKeyConstant[language]['g'] }}
    </div>
  </div>
  <div
    [ngStyle]="{
      display:
        tutorialCount == 13 && language != 'he' && language != 'ar'
          ? 'block'
          : 'none'
    }"
    class="dynamic-card-container translate-top-most"
    [resizeDom]="helpTutorialContentStageNoResizeChild"
  >
    <div
      class="hand-container-13 id-87"
      style="z-index: 2"
      [ngStyle]="{
        width: 62 * scaleR.scaleX + 'px',
        height: 69 * scaleR.scaleX + 'px',
        top: 19 * scaleR.scaleX + 'px',
        left: 92 * scaleR.scaleX + 'px',
        display: currentQuickTipsID == 87 ? 'block' : 'none'
      }"
    >
      <img class="img-hand" [src]="getImageFromQuickTipsSprite('47_hand@2x')" />
      <div
        class="handTextstyle hand-47"
        [ngStyle]="{
          width: 34 * scaleR.scaleX + 'px',
          top: 11 * scaleR.scaleX + 'px',
          left: 4 * scaleR.scaleX + 'px'
        }"
        [resizeText]="currentQuickTipsID <= 99 ? 22 : 20"
      >
        {{ currentQuickTipsID }}
      </div>
    </div>
    <div
      class="hand-container-13 id-85"
      style="z-index: 2"
      [ngStyle]="{
        width: 64 * scaleR.scaleX + 'px',
        height: 75 * scaleR.scaleX + 'px',
        top:
          (splitcardsposition[language].tutorial13Top - 73) * scaleR.scaleX +
          'px',
        left: 44 * scaleR.scaleX + 'px',
        display: currentQuickTipsID == 85 ? 'block' : 'none'
      }"
    >
      <img class="img-hand" [src]="getImageFromQuickTipsSprite('34_hand@2x')" />
      <div
        class="handTextstyle hand-34"
        [ngStyle]="{
          width: 34 * scaleR.scaleX + 'px',
          top: 27 * scaleR.scaleX + 'px',
          left: 9 * scaleR.scaleX + 'px'
        }"
        [resizeText]="22"
      >
        {{ currentQuickTipsID }}
      </div>
    </div>
    <div
      class="hand-container-13 id-86-1"
      style="z-index: 2"
      [ngStyle]="{
        width: 64 * scaleR.scaleX + 'px',
        height: 75 * scaleR.scaleX + 'px',
        top:
          (splitcardsposition[language].tutorial13Top - 73) * scaleR.scaleX +
          'px',
        left: 280 * scaleR.scaleX + 'px',
        display: currentQuickTipsID == 86 ? 'block' : 'none'
      }"
    >
      <img class="img-hand" [src]="getImageFromQuickTipsSprite('34_hand@2x')" />
      <div
        class="handTextstyle hand-34"
        [ngStyle]="{
          width: 34 * scaleR.scaleX + 'px',
          top: 27 * scaleR.scaleX + 'px',
          left: 9 * scaleR.scaleX + 'px'
        }"
        [resizeText]="22"
      >
        {{ currentQuickTipsID }}
      </div>
    </div>
    <div
      class="hand-container-13 id-86-2"
      style="z-index: 2"
      [ngStyle]="{
        width: 64 * scaleR.scaleX + 'px',
        height: 75 * scaleR.scaleX + 'px',
        top:
          (splitcardsposition[language].tutorial13Top - 73) * scaleR.scaleX +
          'px',
        left: 505 * scaleR.scaleX + 'px',
        display: currentQuickTipsID == 86 ? 'block' : 'none'
      }"
    >
      <img class="img-hand" [src]="getImageFromQuickTipsSprite('34_hand@2x')" />
      <div
        class="handTextstyle hand-34"
        [ngStyle]="{
          width: 34 * scaleR.scaleX + 'px',
          top: 27 * scaleR.scaleX + 'px',
          left: 9 * scaleR.scaleX + 'px'
        }"
        [resizeText]="22"
      >
        {{ currentQuickTipsID }}
      </div>
    </div>
  </div>
  <div
    [ngStyle]="{
      display:
        tutorialCount == 13 && (language == 'he' || language == 'ar')
          ? 'block'
          : 'none'
    }"
    class="dynamic-card-container translate-top-most"
    [resizeDom]="helpTutorialContentStageNoResizeChild"
  >
    <div
      class="hand-container-13-ar id-87-ar"
      [ngStyle]="{
        width: 62 * scaleR.scaleX + 'px',
        height: 78 * scaleR.scaleX + 'px',
        top: 5 * scaleR.scaleX + 'px',
        left: 634 * scaleR.scaleX + 'px',
        display: currentQuickTipsID == 87 ? 'block' : 'none'
      }"
    >
      <img class="img-hand" [src]="getImageFromQuickTipsSprite('57_hand@2x')" />
      <div
        class="handTextstyle hand-57"
        [ngStyle]="{
          width: 34 * scaleR.scaleX + 'px',
          top: 14 * scaleR.scaleX + 'px',
          left: 10 * scaleR.scaleX + 'px' ? 'block' : 'none'
        }"
        [resizeText]="22"
      >
        {{ currentQuickTipsID }}
      </div>
    </div>
    <div
      class="hand-container-13-ar id-85-ar"
      [ngStyle]="{
        width: 64 * scaleR.scaleX + 'px',
        height: 75 * scaleR.scaleX + 'px',
        top:
          (splitcardsposition[language].tutorial13Top - 73) * scaleR.scaleX +
          'px',
        left: 520 * scaleR.scaleX + 'px',
        display: currentQuickTipsID == 85 ? 'block' : 'none'
      }"
    >
      <img class="img-hand" [src]="getImageFromQuickTipsSprite('34_hand@2x')" />
      <div
        class="handTextstyle hand-34"
        [ngStyle]="{
          width: 34 * scaleR.scaleX + 'px',
          top: 27 * scaleR.scaleX + 'px',
          left: 9 * scaleR.scaleX + 'px' ? 'block' : 'none'
        }"
        [resizeText]="22"
      >
        {{ currentQuickTipsID }}
      </div>
    </div>
    <div
      class="hand-container-13-ar id-86-1-ar"
      [ngStyle]="{
        width: 64 * scaleR.scaleX + 'px',
        height: 75 * scaleR.scaleX + 'px',
        top:
          (splitcardsposition[language].tutorial13Top - 73) * scaleR.scaleX +
          'px',
        left: 50 * scaleR.scaleX + 'px',
        display: currentQuickTipsID == 86 ? 'block' : 'none'
      }"
    >
      <img class="img-hand" [src]="getImageFromQuickTipsSprite('34_hand@2x')" />
      <div
        class="handTextstyle hand-34"
        [ngStyle]="{
          width: 34 * scaleR.scaleX + 'px',
          top: 27 * scaleR.scaleX + 'px',
          left: 9 * scaleR.scaleX + 'px' ? 'block' : 'none'
        }"
        [resizeText]="22"
      >
        {{ currentQuickTipsID }}
      </div>
    </div>
    <div
      class="hand-container-13-ar id-86-2-ar"
      [ngStyle]="{
        width: 64 * scaleR.scaleX + 'px',
        height: 75 * scaleR.scaleX + 'px',
        top:
          (splitcardsposition[language].tutorial13Top - 73) * scaleR.scaleX +
          'px',
        left: 270 * scaleR.scaleX + 'px',
        display: currentQuickTipsID == 86 ? 'block' : 'none'
      }"
    >
      <img class="img-hand" [src]="getImageFromQuickTipsSprite('34_hand@2x')" />
      <div
        class="handTextstyle hand-34"
        [ngStyle]="{
          width: 34 * scaleR.scaleX + 'px',
          top: 27 * scaleR.scaleX + 'px',
          left: 9 * scaleR.scaleX + 'px' ? 'block' : 'none'
        }"
        [resizeText]="22"
      >
        {{ currentQuickTipsID }}
      </div>
    </div>
  </div>
  <div
    *ngIf="tutorialCount == 20 && language != 'he' && language != 'ar'"
    class="translate-top-most"
    [ngStyle]="{
      width: 394 * scaleR.scaleX + 'px',
      height: 18 * scaleR.scaleX + 'px',
      top: scaleR.offsetTop + 325 * scaleR.scaleX + 'px',
      left: scaleR.offsetLeft + 568 * scaleR.scaleX + 'px'
    }"
    style="
      position: absolute;
      background-color: white;
      z-index: 1005;
      opacity: 0;
    "
    (click)="onGeneralInfoClick($event)"
  ></div>
  <div
    *ngIf="tutorialCount == 20 && (language == 'he' || language == 'ar')"
    class="translate-top-most"
    [ngStyle]="{
      width: 432 * scaleR.scaleX + 'px',
      height: 22 * scaleR.scaleX + 'px',
      top: scaleR.offsetTop + 325 * scaleR.scaleX + 'px',
      left: scaleR.offsetLeft + 312 * scaleR.scaleX + 'px'
    }"
    style="
      position: absolute;
      background-color: white;
      z-index: 1005;
      opacity: 0;
    "
    (click)="onGeneralInfoClick($event)"
  ></div>
</pinch-zoom>
